(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea596"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea596"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kHwbY", function(module, exports) {

$parcel$export(module.exports, "rootDoc", function () { return $f120cb7783768ae8$export$de7ead42144ee87f; });
$parcel$export(module.exports, "_", function () { return $f120cb7783768ae8$export$71511d61b312f219; });
$parcel$export(module.exports, "$", function () { return $f120cb7783768ae8$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "createEl", function () { return $f120cb7783768ae8$export$3d7cd8ed57263b30; });
$parcel$export(module.exports, "createElWithText", function () { return $f120cb7783768ae8$export$ecd10de24f44b999; });
$parcel$export(module.exports, "createElWithHTML", function () { return $f120cb7783768ae8$export$69b2a7fcb8b634f; });
$parcel$export(module.exports, "createImageEl", function () { return $f120cb7783768ae8$export$ee31727d4121fca7; });
$parcel$export(module.exports, "createBtn", function () { return $f120cb7783768ae8$export$258b0eb2f6f9eed2; });
$parcel$export(module.exports, "createBtnWithSpinner", function () { return $f120cb7783768ae8$export$5a1947d71e311350; });
$parcel$export(module.exports, "createFragment", function () { return $f120cb7783768ae8$export$407ea597bae49e98; });
$parcel$export(module.exports, "createCommentsLoader", function () { return $f120cb7783768ae8$export$feaf2b66cedcb511; });
//SELECTORS
const $f120cb7783768ae8$export$de7ead42144ee87f = document.querySelector(":root");
function $f120cb7783768ae8$export$71511d61b312f219(id) {
    return document.getElementById(id);
}
function $f120cb7783768ae8$export$3d8c2f653ac9d0b9(parent, selector) {
    return Array.from(parent.querySelectorAll(selector));
}
function $f120cb7783768ae8$export$3d7cd8ed57263b30(tag, classes, attr) {
    const el = document.createElement(tag);
    el.setAttribute("class", classes);
    if (attr) for(let key in attr)el.setAttribute(key, attr[key]);
    return el;
}
function $f120cb7783768ae8$export$ecd10de24f44b999(tag, classes, text, attr) {
    const el = $f120cb7783768ae8$export$3d7cd8ed57263b30(tag, classes);
    if (attr) for(let key in attr)el.setAttribute(key, attr[key]);
    el.innerText = text;
    return el;
}
function $f120cb7783768ae8$export$69b2a7fcb8b634f(tag, classes, html, attr) {
    const el = $f120cb7783768ae8$export$3d7cd8ed57263b30(tag, classes);
    if (attr) for(let key in attr)el.setAttribute(key, attr[key]);
    el.innerHTML = html;
    return el;
}
function $f120cb7783768ae8$export$ee31727d4121fca7(classes, attr) {
    const img = $f120cb7783768ae8$export$3d7cd8ed57263b30("img", classes);
    for(let key in attr)img.setAttribute(key, attr[key]);
    return img;
}
function $f120cb7783768ae8$export$f235d743d35a42d0(classes, attr) {
    const audio = $f120cb7783768ae8$export$3d7cd8ed57263b30("audio", classes);
    for(let key in attr)audio.setAttribute(key, attr[key]);
    return audio;
}
function $f120cb7783768ae8$export$c34ace1158f06c39(classes, attr) {
    const video = $f120cb7783768ae8$export$3d7cd8ed57263b30("video", classes);
    for(let key in attr)video.setAttribute(key, attr[key]);
    return video;
}
function $f120cb7783768ae8$export$258b0eb2f6f9eed2(classes, attr) {
    const btn = $f120cb7783768ae8$export$ecd10de24f44b999("button", classes, attr.text);
    for(let key in attr)btn.setAttribute(key, attr[key]);
    return btn;
}
function $f120cb7783768ae8$export$5a1947d71e311350(classes, attr) {
    const btn = $f120cb7783768ae8$export$3d7cd8ed57263b30("button", classes);
    for(let key in attr)btn.setAttribute(key, attr[key]);
    const spinner = $f120cb7783768ae8$export$3d7cd8ed57263b30("div", "spinner no-display");
    const span = $f120cb7783768ae8$export$ecd10de24f44b999("span", "btn-span", attr.text);
    btn.append(spinner);
    btn.append(span);
    return btn;
}
function $f120cb7783768ae8$export$407ea597bae49e98(fragments) {
    const fragment = document.createDocumentFragment();
    fragments.forEach((fr)=>fragment.append(fr));
    return fragment;
}
function $f120cb7783768ae8$export$aefe1a6be41e3d0c(tag, classes, target, attr) {
    const el = $f120cb7783768ae8$export$3d7cd8ed57263b30(tag, classes, attr);
    target.append(el);
}
function $f120cb7783768ae8$export$e7e97c57fc2e401c(tag, classes, target, text, attr) {
    const el = $f120cb7783768ae8$export$ecd10de24f44b999(tag, classes, text, attr);
    target.append(el);
}
function $f120cb7783768ae8$export$87eb1d92205d639(tag, classes, target, html, attr) {
    const el = $f120cb7783768ae8$export$69b2a7fcb8b634f(tag, classes, html, attr);
    target.append(el);
}
function $f120cb7783768ae8$export$feaf2b66cedcb511() {
    const wrapper = $f120cb7783768ae8$export$3d7cd8ed57263b30("div", "comments-loader lds-roller-wrapper flex-container flex-center");
    const loader = $f120cb7783768ae8$export$3d7cd8ed57263b30("div", "lds-roller");
    for(let i = 0; i < 8; i++)loader.append($f120cb7783768ae8$export$3d7cd8ed57263b30("div", ""));
    wrapper.append(loader);
    return wrapper;
}

});

parcelRegister("gUYbp", function(module, exports) {

$parcel$export(module.exports, "fetchAPI", function () { return $c5108f6770e1f35f$export$23f83e165e686241; });
async function $c5108f6770e1f35f$export$23f83e165e686241(url, method, payload) {
    const options = {
        method: method,
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    };
    try {
        const response = await fetch(url, options);
        return await response.json();
    } catch (err) {
        console.error(err);
        return {
            error: "An unexpected error occured<br><br>Please check your internet connection"
        };
    }
}

});

parcelRegister("fHkK7", function(module, exports) {

$parcel$export(module.exports, "onRequest", function () { return $b6daf63e507243ef$export$d5625c59bfbbd220; });
$parcel$export(module.exports, "onResponse", function () { return $b6daf63e507243ef$export$e9cd337c777578e7; });

var $kHwbY = parcelRequire("kHwbY");
function $b6daf63e507243ef$export$d5625c59bfbbd220(btn) {
    document.addEventListener("keydown", $b6daf63e507243ef$export$37efd2c65e8bf7e7);
    $b6daf63e507243ef$export$e85650ebb7296dad(true, btn);
    (0, $kHwbY.rootDoc).classList.add("no-pointers");
}
function $b6daf63e507243ef$export$e9cd337c777578e7(btn) {
    document.removeEventListener("keydown", $b6daf63e507243ef$export$37efd2c65e8bf7e7);
    $b6daf63e507243ef$export$e85650ebb7296dad(false, btn);
    (0, $kHwbY.rootDoc).classList.remove("no-pointers");
}
function $b6daf63e507243ef$export$db95ad3a9fbc9f60(loading, spinner, button) {
    if (loading) {
        spinner.classList.remove("no-display");
        button.classList.add("no-display");
    } else {
        spinner.classList.add("no-display");
        button.classList.remove("no-display");
    }
}
const $b6daf63e507243ef$export$e85650ebb7296dad = (isLoading, btn)=>{
    const spinner = (0, $kHwbY.$)(btn, ".spinner")[0];
    const button = (0, $kHwbY.$)(btn, ".btn-span")[0];
    if (isLoading) {
        btn.disabled = true;
        btn.classList.add("btn-disabled");
    } else {
        btn.disabled = false;
        btn.classList.remove("btn-disabled");
    }
    $b6daf63e507243ef$export$db95ad3a9fbc9f60(isLoading, spinner, button);
};
function $b6daf63e507243ef$export$37efd2c65e8bf7e7(e) {
    if (e.code === "Enter") e.preventDefault(); //avoid submitting form
}

});


var $kHwbY = parcelRequire("kHwbY");
let $7cf89b289946013e$export$fc66f88975b715ac = (0, $kHwbY._)("fixedContainer"), $7cf89b289946013e$export$38e42c68cf43b5d4 = (0, $kHwbY._)("header"), $7cf89b289946013e$export$ae8d5403ba7bd299 = (0, $kHwbY._)("headerDrawer"), $7cf89b289946013e$export$7d17b6c055672cbf = (0, $kHwbY._)("sideBarRight"), $7cf89b289946013e$export$763a95d341df07be = (0, $kHwbY._)("sbRightDrawer"), $7cf89b289946013e$export$f2fe88e3db97d3a9 = (0, $kHwbY._)("sbRightTitle"), $7cf89b289946013e$export$dbb963b0b4c07ccb = (0, $kHwbY._)("thumbsWrapper");
const $7cf89b289946013e$export$c2dd313c040ea211 = (0, $kHwbY.$)(document, ".a-links");
let $7cf89b289946013e$export$f509bc23ec5ba01c = (0, $kHwbY._)("genreDropDown");
const $7cf89b289946013e$export$7079e74b16e3deec = (0, $kHwbY.$)(document, ".overlay");
let $7cf89b289946013e$export$fceceec671b9a03e = (0, $kHwbY._)("subscribeOverlay"), $7cf89b289946013e$export$6900740f5ed31f0c = (0, $kHwbY._)("albumOverlay"), $7cf89b289946013e$export$5b895045d367a315 = (0, $kHwbY._)("albumImgOverlay"), $7cf89b289946013e$export$c40d5dfedea4cbef = (0, $kHwbY._)("albumCaption"), $7cf89b289946013e$export$11f729d610486c22 = (0, $kHwbY._)("refreshOverlay"), $7cf89b289946013e$export$48af96f81a30d9f5 = (0, $kHwbY._)("reloadBtn"), $7cf89b289946013e$export$bf3914add3e8ddc4 = (0, $kHwbY._)("errorOverlay");
const $7cf89b289946013e$export$da3bc2f57520e3c3 = (0, $kHwbY.$)(document, ".page");
let $7cf89b289946013e$export$bf1d917a35fc3808 = (0, $kHwbY._)("aboutContent"), $7cf89b289946013e$export$9d6f38182ab5a58 = (0, $kHwbY._)("tapeContent"), $7cf89b289946013e$export$b66170c5a49216c1 = (0, $kHwbY._)("contactContent"), $7cf89b289946013e$export$9fb42d980985e1e5 = (0, $kHwbY._)("privacyContent"), $7cf89b289946013e$export$2659b5099c14f2d9 = (0, $kHwbY._)("siteInfoContent");
let $7cf89b289946013e$export$d10ac07439c9d6e9 = (0, $kHwbY._)("tapeContentEdit"), $7cf89b289946013e$export$81f0481d70653cd4 = (0, $kHwbY._)("downloadZip"), $7cf89b289946013e$export$91a5805f21dad009 = (0, $kHwbY._)("shareFacebook"), $7cf89b289946013e$export$c737a01d319fcd74 = (0, $kHwbY._)("shareTwitter"), $7cf89b289946013e$export$84cce35a26611d0c = (0, $kHwbY._)("shareEmail"), $7cf89b289946013e$export$5d2cfd7a9791e3a1 = (0, $kHwbY._)("playAlbumBtn");
let $7cf89b289946013e$export$d8427b733004933d = (0, $kHwbY._)("commentsWrapper"), $7cf89b289946013e$export$b869561c6ce5c3a8 = (0, $kHwbY._)("commentCount"), $7cf89b289946013e$export$285bd1d6c6bdf942 = (0, $kHwbY._)("commentForm"), $7cf89b289946013e$export$c3148db9874c7cf8 = (0, $kHwbY._)("commentName"), $7cf89b289946013e$export$b13fd998675f85df = (0, $kHwbY._)("commentMsg"), $7cf89b289946013e$export$1d0a7557dbe4123 = (0, $kHwbY._)("commentSubmitBtn");
let $7cf89b289946013e$export$c3c488c05aeea533 = (0, $kHwbY._)("searchResults"), $7cf89b289946013e$export$3bc667280e4eed3 = (0, $kHwbY._)("closeSearchOverlay"), $7cf89b289946013e$export$c8049084115427e0 = (0, $kHwbY._)("searchResultsEdit"), $7cf89b289946013e$export$952af3258ed45903 = (0, $kHwbY._)("searchInput"), $7cf89b289946013e$export$293a7ede9354bee0 = (0, $kHwbY._)("searchValue"), $7cf89b289946013e$export$74fee65ef99e665c = (0, $kHwbY._)("searchTitles"), $7cf89b289946013e$export$dd4db7a8de9ade16 = (0, $kHwbY._)("closeSearch");
let $7cf89b289946013e$export$650cc1adfbebd6d7 = (0, $kHwbY._)("contactForm"), $7cf89b289946013e$export$3713cb6ee3daa0ed = (0, $kHwbY._)("contactName"), $7cf89b289946013e$export$216bebe50ea21113 = (0, $kHwbY._)("contactEmail"), $7cf89b289946013e$export$4bf98324584a107b = (0, $kHwbY._)("contactMsg"), $7cf89b289946013e$export$b43fcfc8816565e2 = (0, $kHwbY._)("contactSubmitBtn");
let $7cf89b289946013e$export$297876223bd08729 = (0, $kHwbY._)("subscribeBtn"), $7cf89b289946013e$export$d14c904650badef2 = (0, $kHwbY._)("closeSubOverlay"), $7cf89b289946013e$export$2132b0054e3f7d8b = (0, $kHwbY._)("subscribeOverlayEdit"), $7cf89b289946013e$export$7b451d4caa7d79cb = (0, $kHwbY._)("subscribeForm"), $7cf89b289946013e$export$70e6340d6978c8c9 = (0, $kHwbY._)("subscribeName"), $7cf89b289946013e$export$2c68f429695ceeec = (0, $kHwbY._)("subscribeEmail"), $7cf89b289946013e$export$d36e32ebd1790b56 = (0, $kHwbY._)("subscribeSubmitBtn"), $7cf89b289946013e$export$817f678afff6e146 = (0, $kHwbY._)("successSVG"), $7cf89b289946013e$export$678ceb1569114bf0 = (0, $kHwbY._)("errorSVG");
let $7cf89b289946013e$export$2621802d134c4be1 = (0, $kHwbY._)("audioPlayerWrapper"), $7cf89b289946013e$export$ee304df6759b31d9 = (0, $kHwbY._)("playerMax"), $7cf89b289946013e$export$753dd2fa9d2ea4eb = (0, $kHwbY._)("playerMin"), $7cf89b289946013e$export$63db5107226e48e6 = (0, $kHwbY._)("expandPlayerBtnMin"), $7cf89b289946013e$export$e2d60959fd2a508b = (0, $kHwbY._)("minimizePlayerBtn"), $7cf89b289946013e$export$d772b7197ca1c91a = (0, $kHwbY._)("progressBar"), $7cf89b289946013e$export$42b08ebc3e1e2efe = (0, $kHwbY._)("progressBarMin"), $7cf89b289946013e$export$718382061dd24162 = (0, $kHwbY._)("volumeBar"), $7cf89b289946013e$export$179d84ebabea5e51 = (0, $kHwbY._)("volumeBarMin"), $7cf89b289946013e$export$bd5a892ec11307f7 = (0, $kHwbY._)("volumeWrapper"), $7cf89b289946013e$export$511725b9a22c4720 = (0, $kHwbY._)("progressDurationMin"), $7cf89b289946013e$export$431e3f571c32911f = (0, $kHwbY._)("progressDuration"), $7cf89b289946013e$export$a256685a6fc760ad = (0, $kHwbY._)("progressRemainder"), $7cf89b289946013e$export$9c75bcdb01643904 = (0, $kHwbY._)("playerTracksEdit");
const $7cf89b289946013e$export$9bee46d052ac3ca9 = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".play-btn");
const $7cf89b289946013e$export$59607e2ac473d722 = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".pause-btn");
const $7cf89b289946013e$export$57c69e255c52c37 = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".prev-btn");
const $7cf89b289946013e$export$24bbc75850254bb1 = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".forward-btn");
const $7cf89b289946013e$export$b067f672a832554 = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".progress-bar");
const $7cf89b289946013e$export$7459f84b8f199f7a = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".progress-wrapper");
const $7cf89b289946013e$export$18ba6c7b0fb1fb63 = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".progress");
const $7cf89b289946013e$export$331c65478e3f60ad = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".volume-btn");
const $7cf89b289946013e$export$48e46af161b66a94 = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".volume");
const $7cf89b289946013e$export$90b8fcb446922726 = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".mute-btn");
const $7cf89b289946013e$export$cf2f17f2190bd04b = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".volume-bar");
const $7cf89b289946013e$export$3327da24f16f12df = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".volume-wrapper");
const $7cf89b289946013e$export$b7a8a2baa1f5277c = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".player-loader");
const $7cf89b289946013e$export$8fbbcf3ec7af5ce6 = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".play-head");
const $7cf89b289946013e$export$39833158fa8e683 = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".player-title span");
const $7cf89b289946013e$export$e1832d917d57b24a = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".player-album span")[0];
const $7cf89b289946013e$export$3294cd9f8252944f = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".player-artist span")[0];
const $7cf89b289946013e$export$c39f490f8a4f174e = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".small-player-thumb")[0];
const $7cf89b289946013e$export$8750d8b69b50cc71 = (0, $kHwbY.$)($7cf89b289946013e$export$2621802d134c4be1, ".big-player-thumb")[0];
let $7cf89b289946013e$export$efad93080758a558 = null, $7cf89b289946013e$export$e5327212f4498715 = null, $7cf89b289946013e$export$3982463a07672884, $7cf89b289946013e$export$72029643ed737dbc, $7cf89b289946013e$export$976d6f037fe75c00 = [], $7cf89b289946013e$export$8ee1df3c6367a60;
function $7cf89b289946013e$export$39ba075b3d63f433() {
    const currentTape = Number($7cf89b289946013e$export$d10ac07439c9d6e9.getAttribute("data-id"));
    $7cf89b289946013e$export$873130819acc7f7(currentTape);
    const scriptDataEl = (0, $kHwbY._)("SERVER_DATA");
    if (!scriptDataEl) return;
    $7cf89b289946013e$export$8ee1df3c6367a60 = scriptDataEl.getAttribute("data-version");
    $7cf89b289946013e$export$976d6f037fe75c00 = JSON.parse(scriptDataEl.textContent);
    if (!$7cf89b289946013e$export$976d6f037fe75c00 || $7cf89b289946013e$export$976d6f037fe75c00.length === 0) return;
    return true;
}
function $7cf89b289946013e$export$7f0f66125aea4b08(val) {
    $7cf89b289946013e$export$3982463a07672884 = val;
}
function $7cf89b289946013e$export$873130819acc7f7(tapeID) {
    $7cf89b289946013e$export$e5327212f4498715 = tapeID;
}
function $7cf89b289946013e$export$5e52cab53995b7b9(page) {
    $7cf89b289946013e$export$efad93080758a558 = page;
}
function $7cf89b289946013e$export$3b4cac8c91b4220d(results) {
    $7cf89b289946013e$export$72029643ed737dbc = results;
}
function $7cf89b289946013e$export$6f6ad33723708cc7(url) {
    return $7cf89b289946013e$export$976d6f037fe75c00.find((tape)=>tape.t_url === url);
}
function $7cf89b289946013e$export$f146105b872a2433(id) {
    return $7cf89b289946013e$export$976d6f037fe75c00.find((tape)=>tape.t_id === id);
}



var $kHwbY = parcelRequire("kHwbY");

var $gUYbp = parcelRequire("gUYbp");

var $kHwbY = parcelRequire("kHwbY");
//STRING MANIP
function $44cbc0a851a934db$export$7d68961ff6256c01(str) {
    if (str === null || str === "") return "";
    else str = str.toString();
    return str.replace(/(<([^>]+)>)/ig, "");
}
function $44cbc0a851a934db$export$e770ebccaf7adcda(string, find, replace) {
    const regex = new RegExp(find, "g");
    return string.replace(regex, replace);
}
function $44cbc0a851a934db$export$3ae94a2503e890a1(date) {
    let newDate = date.split("-");
    let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    return `${months[Number(newDate[1]) - 1]}  ${Number(newDate[2])},  ${newDate[0]}`;
}


function $dbfc4292d7c933aa$export$f681a8129d2e9d28(attr, classes) {
    const form = (0, $kHwbY.createEl)("form", classes);
    for(let key in attr)form.setAttribute(key, attr[key]);
    return form;
}
function $dbfc4292d7c933aa$export$d80fffb1deb3b97e(attr, val) {
    const input = (0, $kHwbY.createEl)("input", "input-fields");
    for(let key in attr)input.setAttribute(key, attr[key]);
    if (val && attr.type != "file") input.value = val;
    return input;
}
function $dbfc4292d7c933aa$export$5b32cb28d9a29894(attr, val) {
    const wrapper = (0, $kHwbY.createEl)("div", "grow-wrap");
    const textArea = (0, $kHwbY.createEl)("textarea", "input-fields");
    for(let key in attr)textArea.setAttribute(key, attr[key]);
    textArea.setAttribute("oninput", `this.parentNode.dataset.replicatedValue = this.value`);
    if (val) textArea.value = (0, $44cbc0a851a934db$export$e770ebccaf7adcda)(val, "<br>", "\n");
    wrapper.append(textArea);
    return wrapper;
}
function $dbfc4292d7c933aa$export$a2a1e8c320d4e05d(form) {
    form.reset();
    const textAreas = (0, $kHwbY.$)(form, "textarea");
    textAreas.forEach((t)=>{
        const growWrap = t.parentElement;
        if (!growWrap) return;
        growWrap.removeAttribute("data-replicated-value");
    });
}



var $fHkK7 = parcelRequire("fHkK7");


var $kHwbY = parcelRequire("kHwbY");


function $438c912f46128e91$export$db198b58be172276(comments, tapeID) {
    const fragments = [];
    const parentComments = comments.filter((c)=>c.c_parentId === null);
    parentComments.forEach((comment)=>{
        const div = (0, $kHwbY.createEl)("div", "comment", {
            "data-id": comment.c_id
        });
        const commentEls = $438c912f46128e91$var$createComment(comment, false);
        commentEls.forEach((e)=>div.append(e));
        const replies = comments.filter((reply)=>reply.c_parentId === comment.c_id);
        replies.forEach((reply)=>{
            const replyDiv = (0, $kHwbY.createEl)("div", "reply");
            const replyEls = $438c912f46128e91$var$createComment(reply, true);
            replyEls.forEach((e)=>replyDiv.append(e));
            div.append(replyDiv);
        });
        fragments.push(div);
    });
    const fragment = (0, $kHwbY.createFragment)(fragments);
    (0, $7cf89b289946013e$export$d8427b733004933d).innerHTML = "";
    (0, $7cf89b289946013e$export$d8427b733004933d).append(fragment);
    $438c912f46128e91$var$updateCommentCount(comments.length);
    (0, $9718690ab11358b5$export$d8c3e97503d199bf)();
    (0, $7cf89b289946013e$export$285bd1d6c6bdf942).setAttribute("data-tape", tapeID.toString());
    (0, $dbfc4292d7c933aa$export$a2a1e8c320d4e05d)((0, $7cf89b289946013e$export$285bd1d6c6bdf942));
}
function $438c912f46128e91$var$updateCommentCount(count) {
    (0, $7cf89b289946013e$export$b869561c6ce5c3a8).setAttribute("data-count", count.toString());
    (0, $7cf89b289946013e$export$b869561c6ce5c3a8).innerText = `(${count})`;
}
function $438c912f46128e91$export$93e55bb748e025f2() {
    (0, $7cf89b289946013e$export$b869561c6ce5c3a8).removeAttribute("data-count");
    (0, $7cf89b289946013e$export$b869561c6ce5c3a8).innerText = "";
}
function $438c912f46128e91$var$createComment(comment, onReply) {
    const header = (0, $kHwbY.createElWithText)("h1", "", comment.c_user);
    const date = (0, $kHwbY.createElWithHTML)("h2", "", `${comment.c_date}<span class="time-zone">(EST)</span>`);
    const text = (0, $kHwbY.createElWithHTML)("p", "tape-content-read", comment.c_comment.replace(/\n/ig, "<br>"));
    if (onReply) return [
        header,
        date,
        text
    ];
    const btn = (0, $kHwbY.createBtn)("btns reply-comment-btn ease-out", {
        type: "button",
        text: "REPLY",
        title: "REPLY"
    });
    return [
        header,
        date,
        text,
        btn
    ];
}


function $9718690ab11358b5$export$d8c3e97503d199bf() {
    const replyBtns = (0, $kHwbY.$)((0, $7cf89b289946013e$export$d8427b733004933d), ".reply-comment-btn");
    replyBtns.forEach((btn)=>btn.addEventListener("click", $9718690ab11358b5$var$onShowReplyForm));
}
function $9718690ab11358b5$var$onShowReplyForm() {
    const replyBtns = (0, $kHwbY.$)((0, $7cf89b289946013e$export$d8427b733004933d), ".reply-comment-btn");
    replyBtns.forEach((btn)=>btn.classList.remove("no-display"));
    const replyForms = (0, $kHwbY.$)((0, $7cf89b289946013e$export$d8427b733004933d), ".reply-form");
    replyForms.forEach((form)=>form.remove());
    const tapeID = (0, $7cf89b289946013e$export$285bd1d6c6bdf942).getAttribute("data-tape");
    this.after($9718690ab11358b5$var$createReplyForm(tapeID));
    this.classList.add("no-display");
    const replyForm = (0, $kHwbY.$)((0, $7cf89b289946013e$export$d8427b733004933d), ".reply-form")[0];
    replyForm.addEventListener("submit", $9718690ab11358b5$export$a3f6de88479c02bd);
}
function $9718690ab11358b5$var$createReplyForm(tapeID) {
    const form = (0, $dbfc4292d7c933aa$export$f681a8129d2e9d28)({
        id: "replyForm",
        "data-tape": tapeID.toString()
    }, "comment-form reply-form flex-container flex-col");
    const input = (0, $dbfc4292d7c933aa$export$d80fffb1deb3b97e)({
        type: "text",
        placeholder: "Your Name",
        required: "required",
        id: "replyName"
    });
    const textArea = (0, $dbfc4292d7c933aa$export$5b32cb28d9a29894)({
        placeholder: "Reply to comment...",
        required: "required",
        id: "replyMsg",
        oninput: `this.style.height = ''; this.style.height = this.scrollHeight + 'px';`
    });
    const button = (0, $kHwbY.createBtnWithSpinner)("btns reply-submit-btn ease-out", {
        type: "submit",
        title: "REPLY",
        text: "REPLY",
        id: "replySubmitBtn"
    });
    form.append(input, textArea, button);
    return form;
}
function $9718690ab11358b5$export$a3f6de88479c02bd(e) {
    e.preventDefault();
    const target = e.currentTarget;
    const onReply = target.id === "replyForm" ? true : false;
    const btn = onReply ? (0, $kHwbY._)("replySubmitBtn") : (0, $7cf89b289946013e$export$1d0a7557dbe4123);
    (0, $fHkK7.onRequest)(btn);
    const name = onReply ? (0, $kHwbY._)("replyName").value.trim() : (0, $7cf89b289946013e$export$c3148db9874c7cf8).value.trim();
    const comment = onReply ? (0, $kHwbY._)("replyMsg").value.trim() : (0, $7cf89b289946013e$export$b13fd998675f85df).value.trim();
    const tape = Number(target.getAttribute("data-tape"));
    const parentId = onReply ? Number(target.parentElement?.getAttribute("data-id")) : null;
    $9718690ab11358b5$var$submitComment({
        name: name,
        comment: comment,
        tape: tape,
        parentId: parentId
    }, btn);
}
async function $9718690ab11358b5$var$submitComment(payload, btn) {
    const resp = await (0, $gUYbp.fetchAPI)("/add-comment", "POST", payload);
    (0, $fHkK7.onResponse)(btn);
    const errorEls = (0, $kHwbY.$)((0, $7cf89b289946013e$export$9d6f38182ab5a58), ".contact-result");
    errorEls.forEach((er)=>er.remove());
    if (resp && resp.error) {
        $9718690ab11358b5$var$appendErrorResult(btn, resp.error);
        return;
    }
    if (resp.insertedComment.c_parentId === null) (0, $dbfc4292d7c933aa$export$a2a1e8c320d4e05d)((0, $7cf89b289946013e$export$285bd1d6c6bdf942)); //ON COMMENT, NOT REPLY
    (0, $438c912f46128e91$export$db198b58be172276)(resp.comments, resp.insertedComment.c_tape);
}
function $9718690ab11358b5$var$appendErrorResult(btn, error) {
    const p = (0, $kHwbY.createElWithHTML)("p", "contact-result error", error);
    const div = btn.getAttribute("id") === "replySubmitBtn" ? (0, $kHwbY.$)((0, $7cf89b289946013e$export$d8427b733004933d), ".reply-form")[0] : (0, $7cf89b289946013e$export$285bd1d6c6bdf942);
    (0, $dbfc4292d7c933aa$export$a2a1e8c320d4e05d)(div);
    div.append(p);
}




var $kHwbY = parcelRequire("kHwbY");

var $gUYbp = parcelRequire("gUYbp");
function $09dc04b5569317e1$export$e06c18951f081b66() {
    setInterval(()=>{
        $09dc04b5569317e1$var$fetchAppVersion();
    }, 86400000); //FETCH APP VERSION AFTER A DAY OF STALE STATE
}
async function $09dc04b5569317e1$var$fetchAppVersion() {
    const payload = {
        version: (0, $7cf89b289946013e$export$8ee1df3c6367a60)
    };
    const resp = await (0, $gUYbp.fetchAPI)("/app-version", "POST", payload);
    console.log(resp);
    if (resp.error || resp.version && resp.version === (0, $7cf89b289946013e$export$8ee1df3c6367a60)) return;
    $09dc04b5569317e1$var$showRefreshOverlay();
}
function $09dc04b5569317e1$var$showRefreshOverlay() {
    (0, $kHwbY.rootDoc).classList.add("no-scroll");
    (0, $7cf89b289946013e$export$11f729d610486c22).classList.remove("no-display");
    setTimeout(()=>{
        (0, $7cf89b289946013e$export$11f729d610486c22).classList.add("overlay-change");
    }, 100);
    (0, $7cf89b289946013e$export$48af96f81a30d9f5).addEventListener("click", $09dc04b5569317e1$var$forceRefresh);
}
function $09dc04b5569317e1$var$forceRefresh() {
    location.reload();
}




var $kHwbY = parcelRequire("kHwbY");


var $kHwbY = parcelRequire("kHwbY");


var $kHwbY = parcelRequire("kHwbY");




function $5195ce8cc6653e87$export$d12f9c456f9edae9(data, prop) {
    return data.map((item)=>{
        return item[prop];
    });
}
function $5195ce8cc6653e87$export$a1cc11fb93586ff0(data, obj, prop) {
    return data.map((item)=>{
        return item[obj][prop];
    });
}
const $5195ce8cc6653e87$export$6fa12653dd5e73ee = (data, prop)=>{
    return data.map((a)=>a).sort((a, b)=>String(a[prop]).localeCompare(String(b[prop])));
};
function $5195ce8cc6653e87$export$cfd5ab1416f9abda(data, obj, prop) {
    return data.map((a)=>a).sort((a, b)=>String(a[obj][prop]).localeCompare(String(b[obj][prop])));
}
function $5195ce8cc6653e87$export$2ae56b58f6d8d75e(data, prop, val) {
    return data.find((rec)=>String(rec[prop]) === val);
}
function $5195ce8cc6653e87$export$64a79c6b55760f81(data, search) {
    return data.filter((row)=>String(row).toLowerCase().includes(search));
}
function $5195ce8cc6653e87$export$4563b0c2631818ea(data, prop, search) {
    return data.filter((row)=>String(row[prop]).toLowerCase().includes(search));
}
function $5195ce8cc6653e87$export$22e259274f125c53(data, prop) {
    return data.map((a)=>a).sort((a, b)=>Number(b[prop]) - Number(a[prop]));
}
function $5195ce8cc6653e87$export$5f59d3db2476269f(data, keys) {
    keys.forEach((key)=>{
        delete data[key];
    });
    return data;
}





let $0d29b55a1648e022$export$a916eedc414b5fe2, $0d29b55a1648e022$export$6c80d3759e7d625a = 0, $0d29b55a1648e022$export$aec0db44587e9b98 = [], $0d29b55a1648e022$export$b8409547504d7154 = [], $0d29b55a1648e022$export$9ee07ea3b6a18798 = [], $0d29b55a1648e022$export$54619902c4786752 = 0, $0d29b55a1648e022$export$4bfb50f1a30a41b5 = 0, $0d29b55a1648e022$export$84f0947443291134 = "", $0d29b55a1648e022$export$63b2a00a0de4d5d5 = "", $0d29b55a1648e022$export$36142d7ce666aa46 = false, $0d29b55a1648e022$export$7c55482e4966fd92 = false, $0d29b55a1648e022$export$a63dec0667c2f97a = false, $0d29b55a1648e022$export$481fa8bc5a4102b = 1;
function $0d29b55a1648e022$export$9eaa806651dd33f0(val) {
    $0d29b55a1648e022$export$a63dec0667c2f97a = val;
}
function $0d29b55a1648e022$export$d3f967bfe675254b(num) {
    $0d29b55a1648e022$export$54619902c4786752 = num;
}
function $0d29b55a1648e022$export$135a16a4657aced2(val) {
    $0d29b55a1648e022$export$36142d7ce666aa46 = val;
}
function $0d29b55a1648e022$export$a0a30c6cd614ce91(num) {
    $0d29b55a1648e022$export$481fa8bc5a4102b = num;
}
function $0d29b55a1648e022$export$dcbe983eebabe3ad(val) {
    $0d29b55a1648e022$export$7c55482e4966fd92 = val;
}
function $0d29b55a1648e022$export$a046f014b0330bfe() {
    if ((0, $7cf89b289946013e$export$2621802d134c4be1).classList.contains("transform-y-100") && (0, $7cf89b289946013e$export$2621802d134c4be1).classList.contains("no-display")) {
        (0, $7cf89b289946013e$export$2621802d134c4be1).classList.remove("no-display");
        $0d29b55a1648e022$export$a916eedc414b5fe2 = new Audio();
        setTimeout(()=>{
            (0, $7cf89b289946013e$export$2621802d134c4be1).classList.remove("transform-y-100");
        }, 10);
        (0, $068d387c215a8f86$export$f2ae909814c51424)();
    }
    const tapeID = Number(this.getAttribute("data-id"));
    if (tapeID === $0d29b55a1648e022$export$6c80d3759e7d625a) {
        $0d29b55a1648e022$export$54619902c4786752 = Number(this.getAttribute("data-track"));
        (0, $068d387c215a8f86$export$cfa985a9cecdb0d4)();
        $0d29b55a1648e022$export$a916eedc414b5fe2.src = $0d29b55a1648e022$export$9ee07ea3b6a18798[$0d29b55a1648e022$export$54619902c4786752];
        (0, $068d387c215a8f86$export$1e3b2f48068fd04f)();
        (0, $68038d6a52830ca9$export$fe0c3e1ed8bdfaf4)();
        (0, $04d78f56f2937827$export$7b0d3317162e73ac)();
    } else {
        const id = Number(this.getAttribute("data-id"));
        $0d29b55a1648e022$export$54619902c4786752 = Number(this.getAttribute("data-track"));
        const tape = (0, $7cf89b289946013e$export$f146105b872a2433)(tapeID);
        if (!tape) return;
        $0d29b55a1648e022$var$initAudio(tape);
    }
}
function $0d29b55a1648e022$var$initAudio(data) {
    $0d29b55a1648e022$export$9ee07ea3b6a18798.length = 0;
    $0d29b55a1648e022$export$b8409547504d7154.length = 0;
    $0d29b55a1648e022$export$aec0db44587e9b98.length = 0;
    $0d29b55a1648e022$export$6c80d3759e7d625a = data.t_id;
    const durArr = [
        ...(0, $5195ce8cc6653e87$export$d12f9c456f9edae9)(data.t_assets.sideA, "dur"),
        ...(0, $5195ce8cc6653e87$export$d12f9c456f9edae9)(data.t_assets.sideB, "dur")
    ]; //avoid rewriting on original object
    const srcArr = [
        ...(0, $5195ce8cc6653e87$export$d12f9c456f9edae9)(data.t_assets.sideA, "src"),
        ...(0, $5195ce8cc6653e87$export$d12f9c456f9edae9)(data.t_assets.sideB, "src")
    ]; //avoid rewriting on original object
    const trackArr = [
        ...(0, $5195ce8cc6653e87$export$d12f9c456f9edae9)(data.t_assets.sideA, "title"),
        ...(0, $5195ce8cc6653e87$export$d12f9c456f9edae9)(data.t_assets.sideB, "title")
    ]; //avoid rewriting on original object
    $0d29b55a1648e022$export$aec0db44587e9b98 = durArr;
    $0d29b55a1648e022$export$9ee07ea3b6a18798 = srcArr;
    $0d29b55a1648e022$export$b8409547504d7154 = trackArr;
    $0d29b55a1648e022$export$4bfb50f1a30a41b5 = $0d29b55a1648e022$export$b8409547504d7154.length;
    $0d29b55a1648e022$export$a916eedc414b5fe2.src = $0d29b55a1648e022$export$9ee07ea3b6a18798[$0d29b55a1648e022$export$54619902c4786752];
    $0d29b55a1648e022$export$84f0947443291134 = data.t_album;
    $0d29b55a1648e022$export$63b2a00a0de4d5d5 = data.t_artist;
    (0, $068d387c215a8f86$export$1e3b2f48068fd04f)();
    (0, $68038d6a52830ca9$export$201bb079ed774dc2)();
    (0, $68038d6a52830ca9$export$279da5faa6d9fbc2)();
    (0, $68038d6a52830ca9$export$fe0c3e1ed8bdfaf4)();
    (0, $68038d6a52830ca9$export$fcacf15084f21e8a)(data.t_assets.img_src);
    (0, $04d78f56f2937827$export$7b0d3317162e73ac)();
}




var $kHwbY = parcelRequire("kHwbY");


function $c6ba77fbe1878396$export$d2f8f6f89a308862(e) {
    e = e || window.event;
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).pause();
    const el = (0, $0d29b55a1648e022$export$7c55482e4966fd92) ? (0, $7cf89b289946013e$export$d772b7197ca1c91a) : (0, $kHwbY.$)(document, ".player-middle")[0];
    const padding = (0, $0d29b55a1648e022$export$7c55482e4966fd92) ? 0 : 15;
    const layerX = (0, $7cf89b289946013e$export$3982463a07672884) ? e.targetTouches[0].clientX : e.clientX;
    const offsetX = layerX - el.getBoundingClientRect().x - padding;
    $c6ba77fbe1878396$var$updateThumbPos(offsetX);
    if (0, $7cf89b289946013e$export$3982463a07672884) {
        (0, $7cf89b289946013e$export$8fbbcf3ec7af5ce6).forEach((p)=>p.classList.add("play-head-touch-change"));
        (0, $7cf89b289946013e$export$7459f84b8f199f7a).forEach((wrapper)=>{
            wrapper.addEventListener("touchmove", $c6ba77fbe1878396$var$onThumbMove);
            wrapper.addEventListener("touchend", $c6ba77fbe1878396$var$onThumbUp);
        });
    } else {
        document.addEventListener("mousemove", $c6ba77fbe1878396$var$onThumbMove);
        document.addEventListener("mouseup", $c6ba77fbe1878396$var$onThumbUp);
    }
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).removeEventListener("ended", (0, $068d387c215a8f86$export$eba1cd81b7ebc55d));
}
function $c6ba77fbe1878396$var$updateThumbPos(offsetX) {
    const progressBar = (0, $0d29b55a1648e022$export$7c55482e4966fd92) ? (0, $7cf89b289946013e$export$d772b7197ca1c91a) : (0, $7cf89b289946013e$export$42b08ebc3e1e2efe);
    const perc = Math.max(Math.min(offsetX / progressBar.offsetWidth, 1) * 100, 0);
    $c6ba77fbe1878396$var$updateTime(perc);
}
function $c6ba77fbe1878396$var$updateTime(perc) {
    const duration = isNaN((0, $0d29b55a1648e022$export$a916eedc414b5fe2).duration) ? 0 : (0, $0d29b55a1648e022$export$a916eedc414b5fe2).duration;
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).currentTime = perc * duration / 100;
    $c6ba77fbe1878396$export$3eedb93c9f9c59b2();
}
function $c6ba77fbe1878396$var$onThumbMove(e) {
    e = e || window.event;
    const el = (0, $0d29b55a1648e022$export$7c55482e4966fd92) ? (0, $7cf89b289946013e$export$d772b7197ca1c91a) : (0, $kHwbY.$)(document, ".player-middle")[0];
    const padding = (0, $0d29b55a1648e022$export$7c55482e4966fd92) ? 0 : 15;
    const layerX = (0, $7cf89b289946013e$export$3982463a07672884) ? e.targetTouches[0].clientX : e.clientX;
    const offsetX = layerX - el.getBoundingClientRect().x - padding;
    $c6ba77fbe1878396$var$updateThumbPos(offsetX);
}
function $c6ba77fbe1878396$var$onThumbUp(e) {
    e = e || window.event;
    const el = (0, $0d29b55a1648e022$export$7c55482e4966fd92) ? (0, $7cf89b289946013e$export$d772b7197ca1c91a) : (0, $kHwbY.$)(document, ".player-middle")[0];
    const padding = (0, $0d29b55a1648e022$export$7c55482e4966fd92) ? 0 : 15;
    const layerX = (0, $7cf89b289946013e$export$3982463a07672884) ? e.changedTouches[0].clientX : e.clientX;
    const offsetX = layerX - el.getBoundingClientRect().x - padding;
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).addEventListener("ended", (0, $068d387c215a8f86$export$eba1cd81b7ebc55d));
    $c6ba77fbe1878396$var$updateThumbPos(offsetX);
    if (0, $0d29b55a1648e022$export$36142d7ce666aa46) {
        if ((0, $7cf89b289946013e$export$18ba6c7b0fb1fb63)[0].style.width === "100%") (0, $068d387c215a8f86$export$eba1cd81b7ebc55d)();
        else (0, $0d29b55a1648e022$export$a916eedc414b5fe2).play();
    }
    if (0, $7cf89b289946013e$export$3982463a07672884) {
        (0, $7cf89b289946013e$export$8fbbcf3ec7af5ce6).forEach((p)=>p.classList.remove("play-head-touch-change"));
        (0, $7cf89b289946013e$export$7459f84b8f199f7a).forEach((wrapper)=>{
            wrapper.removeEventListener("touchmove", $c6ba77fbe1878396$var$onThumbMove);
            wrapper.removeEventListener("touchend", $c6ba77fbe1878396$var$onThumbUp);
        });
    } else {
        document.removeEventListener("mousemove", $c6ba77fbe1878396$var$onThumbMove);
        document.removeEventListener("mouseup", $c6ba77fbe1878396$var$onThumbUp);
    }
}
function $c6ba77fbe1878396$export$3eedb93c9f9c59b2() {
    const perc = (0, $0d29b55a1648e022$export$a916eedc414b5fe2).currentTime / (0, $0d29b55a1648e022$export$a916eedc414b5fe2).duration * 100;
    (0, $7cf89b289946013e$export$18ba6c7b0fb1fb63).forEach((p)=>p.style.width = `${perc}%`);
    (0, $7cf89b289946013e$export$8fbbcf3ec7af5ce6).forEach((p)=>p.style.left = `${perc}%`);
    const duration = isNaN((0, $0d29b55a1648e022$export$a916eedc414b5fe2).duration) ? "0:00" : $c6ba77fbe1878396$var$formatAudioTime((0, $0d29b55a1648e022$export$a916eedc414b5fe2).duration);
    (0, $7cf89b289946013e$export$511725b9a22c4720).innerHTML = `${$c6ba77fbe1878396$var$formatAudioTime((0, $0d29b55a1648e022$export$a916eedc414b5fe2).currentTime)} / ${duration}`;
    (0, $7cf89b289946013e$export$431e3f571c32911f).innerHTML = `${$c6ba77fbe1878396$var$formatAudioTime((0, $0d29b55a1648e022$export$a916eedc414b5fe2).currentTime)}`;
    (0, $7cf89b289946013e$export$a256685a6fc760ad).innerHTML = isNaN((0, $0d29b55a1648e022$export$a916eedc414b5fe2).duration) ? "0:00" : `-${$c6ba77fbe1878396$var$formatAudioTime((0, $0d29b55a1648e022$export$a916eedc414b5fe2).duration - (0, $0d29b55a1648e022$export$a916eedc414b5fe2).currentTime)}`;
}
function $c6ba77fbe1878396$var$formatAudioTime(duration) {
    let totalMin = Math.floor(duration / 60);
    let totalSec = Math.floor(duration - totalMin * 60);
    totalMin = totalMin < 10 ? `${totalMin}` : totalMin;
    totalSec = totalSec < 10 ? `0${totalSec}` : totalSec;
    return `${totalMin}:${totalSec}`;
}




var $kHwbY = parcelRequire("kHwbY");

function $73e9b1d2f17e8c22$export$d0db5f23ec79fc16() {
    (0, $7cf89b289946013e$export$331c65478e3f60ad).forEach((btn)=>{
        if (btn.classList.contains("no-display")) {
            btn.classList.remove("no-display");
            (0, $7cf89b289946013e$export$90b8fcb446922726).forEach((m)=>m.classList.add("no-display"));
        } else {
            btn.classList.add("no-display");
            (0, $7cf89b289946013e$export$90b8fcb446922726).forEach((m)=>m.classList.remove("no-display"));
        }
    });
    if ((0, $0d29b55a1648e022$export$a916eedc414b5fe2).muted) {
        (0, $0d29b55a1648e022$export$a916eedc414b5fe2).muted = false;
        (0, $0d29b55a1648e022$export$a916eedc414b5fe2).volume = (0, $0d29b55a1648e022$export$481fa8bc5a4102b);
        (0, $7cf89b289946013e$export$48e46af161b66a94).forEach((r)=>r.style.width = (0, $0d29b55a1648e022$export$481fa8bc5a4102b) * 100 + "%");
    } else {
        (0, $0d29b55a1648e022$export$a916eedc414b5fe2).muted = true;
        (0, $7cf89b289946013e$export$48e46af161b66a94).forEach((r)=>r.style.width = "0px");
    }
}
function $73e9b1d2f17e8c22$export$faa87359a0c21ee5(e) {
    e = e || window.event;
    const offsetX = e.offsetX;
    $73e9b1d2f17e8c22$var$updateVolume(offsetX);
    document.addEventListener("mousemove", $73e9b1d2f17e8c22$var$onVolumeMove);
    document.addEventListener("mouseup", $73e9b1d2f17e8c22$var$onVolumeUp);
}
function $73e9b1d2f17e8c22$var$onVolumeMove(e) {
    e = e || window.event;
    const el = (0, $0d29b55a1648e022$export$7c55482e4966fd92) ? (0, $7cf89b289946013e$export$718382061dd24162) : (0, $7cf89b289946013e$export$179d84ebabea5e51);
    const offsetX = e.clientX - el.getBoundingClientRect().x;
    $73e9b1d2f17e8c22$var$updateVolume(offsetX);
}
function $73e9b1d2f17e8c22$var$onVolumeUp() {
    document.removeEventListener("mousemove", $73e9b1d2f17e8c22$var$onVolumeMove);
    document.removeEventListener("mouseup", $73e9b1d2f17e8c22$var$onVolumeUp);
}
function $73e9b1d2f17e8c22$var$updateVolume(offsetX) {
    const el = (0, $0d29b55a1648e022$export$7c55482e4966fd92) ? (0, $7cf89b289946013e$export$718382061dd24162) : (0, $7cf89b289946013e$export$179d84ebabea5e51);
    const value = Math.min(Math.max(offsetX / (el.offsetWidth || 1), 0), 1);
    if (value > 0) (0, $0d29b55a1648e022$export$a916eedc414b5fe2).muted = false;
    else (0, $0d29b55a1648e022$export$a916eedc414b5fe2).muted = true;
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).volume = value;
    (0, $0d29b55a1648e022$export$a0a30c6cd614ce91)(value);
    (0, $7cf89b289946013e$export$48e46af161b66a94).forEach((r)=>r.style.width = value * 100 + "%");
    (0, $7cf89b289946013e$export$90b8fcb446922726).forEach((m)=>m.classList.add("no-display"));
    (0, $7cf89b289946013e$export$331c65478e3f60ad).forEach((v)=>{
        v.classList.remove("no-display");
        const waves = (0, $kHwbY.$)(v, ".volume-waves");
        waves.forEach((wave)=>wave.style.visibility = "visible");
        if (value <= .66 && value > .33) waves[waves.length - 1].style.visibility = "hidden";
        else if (value <= .33 && value > 0) {
            waves[waves.length - 1].style.visibility = "hidden";
            waves[waves.length - 2].style.visibility = "hidden";
        } else if (value === 0) {
            waves.forEach((wave)=>wave.style.visibility = "hidden");
            (0, $7cf89b289946013e$export$331c65478e3f60ad).forEach((a)=>a.classList.add("no-display"));
            (0, $7cf89b289946013e$export$90b8fcb446922726).forEach((m)=>m.classList.remove("no-display"));
        }
    });
}


function $068d387c215a8f86$export$f2ae909814c51424() {
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).addEventListener("timeupdate", (0, $c6ba77fbe1878396$export$3eedb93c9f9c59b2));
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).addEventListener("loadeddata", (0, $c6ba77fbe1878396$export$3eedb93c9f9c59b2));
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).addEventListener("ended", $068d387c215a8f86$export$eba1cd81b7ebc55d);
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).addEventListener("loadstart", $068d387c215a8f86$var$onLoadStart);
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).addEventListener("loadedmetadata", $068d387c215a8f86$var$onLoadEnd);
    (0, $7cf89b289946013e$export$9bee46d052ac3ca9).forEach((btn)=>btn.addEventListener("click", $068d387c215a8f86$var$onPlayPause));
    (0, $7cf89b289946013e$export$59607e2ac473d722).forEach((btn)=>btn.addEventListener("click", $068d387c215a8f86$var$onPlayPause));
    (0, $7cf89b289946013e$export$57c69e255c52c37).forEach((btn)=>btn.addEventListener("click", $068d387c215a8f86$var$onPrev));
    (0, $7cf89b289946013e$export$24bbc75850254bb1).forEach((btn)=>btn.addEventListener("click", $068d387c215a8f86$export$eba1cd81b7ebc55d));
    (0, $7cf89b289946013e$export$331c65478e3f60ad).forEach((btn)=>btn.addEventListener("click", (0, $73e9b1d2f17e8c22$export$d0db5f23ec79fc16)));
    (0, $7cf89b289946013e$export$90b8fcb446922726).forEach((btn)=>btn.addEventListener("click", (0, $73e9b1d2f17e8c22$export$d0db5f23ec79fc16)));
    if (0, $7cf89b289946013e$export$3982463a07672884) {
        (0, $7cf89b289946013e$export$7459f84b8f199f7a).forEach((btn)=>btn.addEventListener("touchstart", (0, $c6ba77fbe1878396$export$d2f8f6f89a308862)));
        (0, $7cf89b289946013e$export$bd5a892ec11307f7).classList.add("no-display");
        (0, $7cf89b289946013e$export$3327da24f16f12df).forEach((v)=>v.classList.add("no-display"));
    } else {
        (0, $7cf89b289946013e$export$b067f672a832554).forEach((btn)=>btn.addEventListener("mousedown", (0, $c6ba77fbe1878396$export$d2f8f6f89a308862)));
        (0, $7cf89b289946013e$export$cf2f17f2190bd04b).forEach((btn)=>btn.addEventListener("mousedown", (0, $73e9b1d2f17e8c22$export$faa87359a0c21ee5)));
    }
    (0, $7cf89b289946013e$export$63db5107226e48e6).addEventListener("click", (0, $68038d6a52830ca9$export$1707dd3e1c8aa93b));
    (0, $7cf89b289946013e$export$e2d60959fd2a508b).addEventListener("click", (0, $68038d6a52830ca9$export$1707dd3e1c8aa93b));
    document.addEventListener("keydown", $068d387c215a8f86$var$onSpaceBar);
    window.addEventListener("resize", (0, $04d78f56f2937827$export$7b0d3317162e73ac));
}
//ON LOAD START/END
function $068d387c215a8f86$var$onLoadStart() {
    (0, $0d29b55a1648e022$export$9eaa806651dd33f0)(true);
    const selector = !(0, $0d29b55a1648e022$export$36142d7ce666aa46) ? (0, $7cf89b289946013e$export$9bee46d052ac3ca9) : (0, $7cf89b289946013e$export$59607e2ac473d722);
    (0, $7cf89b289946013e$export$b7a8a2baa1f5277c).forEach((btn)=>btn.classList.remove("no-display"));
    selector.forEach((btn)=>btn.classList.add("no-display"));
}
function $068d387c215a8f86$var$onLoadEnd() {
    const selector = !(0, $0d29b55a1648e022$export$36142d7ce666aa46) ? (0, $7cf89b289946013e$export$9bee46d052ac3ca9) : (0, $7cf89b289946013e$export$59607e2ac473d722);
    (0, $7cf89b289946013e$export$b7a8a2baa1f5277c).forEach((btn)=>btn.classList.add("no-display"));
    selector.forEach((btn)=>btn.classList.remove("no-display"));
    (0, $0d29b55a1648e022$export$9eaa806651dd33f0)(false);
}
//TRANSPORT CONTROLS
function $068d387c215a8f86$var$onSpaceBar(e) {
    const target = e.target;
    if (target.nodeName != "INPUT" && target.nodeName != "TEXTAREA") {
        if (e.code === "Space" || e.keyCode === 32) {
            e.preventDefault(); //avoid automatic scrolling page down
            if (!(0, $0d29b55a1648e022$export$a63dec0667c2f97a)) $068d387c215a8f86$var$onPlayPause();
        }
    }
}
function $068d387c215a8f86$var$onPlayPause() {
    if ((0, $0d29b55a1648e022$export$a916eedc414b5fe2).paused) {
        $068d387c215a8f86$export$1e3b2f48068fd04f();
        (0, $68038d6a52830ca9$export$e3e8cd2387b7e37b)(false);
    } else {
        $068d387c215a8f86$export$cfa985a9cecdb0d4();
        (0, $68038d6a52830ca9$export$e3e8cd2387b7e37b)(true);
    }
}
function $068d387c215a8f86$export$1e3b2f48068fd04f() {
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).play();
    (0, $7cf89b289946013e$export$9bee46d052ac3ca9).forEach((btn)=>btn.classList.add("no-display"));
    (0, $7cf89b289946013e$export$59607e2ac473d722).forEach((btn)=>btn.classList.remove("no-display"));
    (0, $0d29b55a1648e022$export$135a16a4657aced2)(true);
}
function $068d387c215a8f86$export$cfa985a9cecdb0d4() {
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).pause();
    (0, $7cf89b289946013e$export$9bee46d052ac3ca9).forEach((btn)=>btn.classList.remove("no-display"));
    (0, $7cf89b289946013e$export$59607e2ac473d722).forEach((btn)=>btn.classList.add("no-display"));
    (0, $0d29b55a1648e022$export$135a16a4657aced2)(false);
}
function $068d387c215a8f86$export$eba1cd81b7ebc55d() {
    if ((0, $0d29b55a1648e022$export$54619902c4786752) === (0, $0d29b55a1648e022$export$4bfb50f1a30a41b5) - 1) {
        $068d387c215a8f86$export$cfa985a9cecdb0d4();
        (0, $68038d6a52830ca9$export$e3e8cd2387b7e37b)(true);
        (0, $0d29b55a1648e022$export$a916eedc414b5fe2).currentTime = 0;
    } else {
        (0, $0d29b55a1648e022$export$a916eedc414b5fe2).pause();
        (0, $0d29b55a1648e022$export$d3f967bfe675254b)((0, $0d29b55a1648e022$export$54619902c4786752) + 1);
        (0, $0d29b55a1648e022$export$a916eedc414b5fe2).src = (0, $0d29b55a1648e022$export$9ee07ea3b6a18798)[0, $0d29b55a1648e022$export$54619902c4786752];
        (0, $68038d6a52830ca9$export$fe0c3e1ed8bdfaf4)();
        if (0, $0d29b55a1648e022$export$36142d7ce666aa46) (0, $0d29b55a1648e022$export$a916eedc414b5fe2).play();
    }
    (0, $04d78f56f2937827$export$7b0d3317162e73ac)();
}
function $068d387c215a8f86$var$onPrev() {
    if ((0, $0d29b55a1648e022$export$54619902c4786752) === 0) {
        $068d387c215a8f86$export$cfa985a9cecdb0d4();
        (0, $68038d6a52830ca9$export$e3e8cd2387b7e37b)(true);
        (0, $0d29b55a1648e022$export$a916eedc414b5fe2).currentTime = 0;
    } else {
        (0, $0d29b55a1648e022$export$a916eedc414b5fe2).pause();
        (0, $0d29b55a1648e022$export$d3f967bfe675254b)((0, $0d29b55a1648e022$export$54619902c4786752) - 1);
        (0, $0d29b55a1648e022$export$a916eedc414b5fe2).src = (0, $0d29b55a1648e022$export$9ee07ea3b6a18798)[0, $0d29b55a1648e022$export$54619902c4786752];
        (0, $68038d6a52830ca9$export$fe0c3e1ed8bdfaf4)();
        if (0, $0d29b55a1648e022$export$36142d7ce666aa46) (0, $0d29b55a1648e022$export$a916eedc414b5fe2).play();
    }
    (0, $04d78f56f2937827$export$7b0d3317162e73ac)();
}




function $68038d6a52830ca9$export$fe0c3e1ed8bdfaf4() {
    (0, $7cf89b289946013e$export$39833158fa8e683).forEach((title)=>title.innerText = `${0, $0d29b55a1648e022$export$63b2a00a0de4d5d5} | ${(0, $0d29b55a1648e022$export$b8409547504d7154)[0, $0d29b55a1648e022$export$54619902c4786752]}`);
    $68038d6a52830ca9$export$e3e8cd2387b7e37b(false);
}
function $68038d6a52830ca9$export$201bb079ed774dc2() {
    (0, $7cf89b289946013e$export$e1832d917d57b24a).innerText = (0, $0d29b55a1648e022$export$84f0947443291134);
    (0, $7cf89b289946013e$export$3294cd9f8252944f).innerText = (0, $0d29b55a1648e022$export$63b2a00a0de4d5d5);
}
function $68038d6a52830ca9$export$279da5faa6d9fbc2() {
    const fragments = [];
    (0, $0d29b55a1648e022$export$b8409547504d7154).forEach((row, index)=>{
        const div = (0, $kHwbY.createEl)("div", "player-tracks flex-container", {
            "data-track": index
        });
        const track = (0, $kHwbY.createElWithHTML)("p", "player-track marquee mask-gradient-5-perc", `<span>${row}</span>`);
        const dur = (0, $kHwbY.createElWithHTML)("p", "player-dur", (0, $0d29b55a1648e022$export$aec0db44587e9b98)[index]);
        div.append(track, dur);
        fragments.push(div);
    });
    const fragment = (0, $kHwbY.createFragment)(fragments);
    (0, $7cf89b289946013e$export$9c75bcdb01643904).innerHTML = "";
    (0, $7cf89b289946013e$export$9c75bcdb01643904).append(fragment);
    const tracks = (0, $kHwbY.$)((0, $7cf89b289946013e$export$9c75bcdb01643904), ".player-tracks");
    tracks.forEach((tr)=>tr.addEventListener("click", $68038d6a52830ca9$var$onPlayerMaxTrackClick));
}
function $68038d6a52830ca9$export$fcacf15084f21e8a(src) {
    (0, $7cf89b289946013e$export$c39f490f8a4f174e).setAttribute("style", `background-image:url(${src});`);
    (0, $7cf89b289946013e$export$8750d8b69b50cc71).setAttribute("style", `background-image:url(${src});`);
}
function $68038d6a52830ca9$export$e3e8cd2387b7e37b(onAudioOff) {
    const tracks = (0, $kHwbY.$)((0, $7cf89b289946013e$export$2621802d134c4be1), ".player-tracks");
    tracks.forEach((tr)=>tr.classList.remove("player-tracks-active"));
    const playing = (0, $kHwbY.$)((0, $7cf89b289946013e$export$2621802d134c4be1), ".playing")[0];
    if (playing) playing.remove();
    if (!onAudioOff) {
        const current = tracks.find((node)=>Number(node.getAttribute("data-track")) === (0, $0d29b55a1648e022$export$54619902c4786752));
        if (!current) return;
        current.classList.add("player-tracks-active");
        if (0, $0d29b55a1648e022$export$36142d7ce666aa46) {
            const track = (0, $kHwbY.$)(current, ".player-track")[0];
            track.after($68038d6a52830ca9$var$createPlayingLoader());
        }
    }
}
function $68038d6a52830ca9$var$createPlayingLoader() {
    const div = (0, $kHwbY.createEl)("div", "playing flex-container");
    for(let i = 1; i < 4; i++){
        const child = (0, $kHwbY.createEl)("span", `playing-bar playing-bar${i}`);
        div.append(child);
    }
    return div;
}
function $68038d6a52830ca9$var$onPlayerMaxTrackClick() {
    (0, $0d29b55a1648e022$export$d3f967bfe675254b)(Number(this.getAttribute("data-track")));
    (0, $0d29b55a1648e022$export$a916eedc414b5fe2).src = (0, $0d29b55a1648e022$export$9ee07ea3b6a18798)[0, $0d29b55a1648e022$export$54619902c4786752];
    (0, $068d387c215a8f86$export$1e3b2f48068fd04f)();
    $68038d6a52830ca9$export$fe0c3e1ed8bdfaf4();
    (0, $04d78f56f2937827$export$7b0d3317162e73ac)();
}
//TOGGLE PLAYER MIN/MAX
function $68038d6a52830ca9$var$onPlayerMax() {
    (0, $7cf89b289946013e$export$2621802d134c4be1).classList.add("audio-player-max");
    (0, $7cf89b289946013e$export$ee304df6759b31d9).classList.remove("no-display");
    (0, $7cf89b289946013e$export$753dd2fa9d2ea4eb).classList.add("no-display");
    (0, $kHwbY.rootDoc).classList.add("no-scroll");
    (0, $kHwbY.rootDoc).classList.add("no-select");
    (0, $0d29b55a1648e022$export$dcbe983eebabe3ad)(true);
    (0, $04d78f56f2937827$export$7b0d3317162e73ac)();
}
function $68038d6a52830ca9$export$e492ffcefbc39bd2() {
    (0, $7cf89b289946013e$export$2621802d134c4be1).addEventListener("transitionend", $68038d6a52830ca9$var$onPlayerMinTransition);
    (0, $7cf89b289946013e$export$2621802d134c4be1).classList.remove("audio-player-max");
}
function $68038d6a52830ca9$var$onPlayerMinTransition(e) {
    e = e || window.event;
    const target = e.currentTarget;
    if (e.propertyName === "height") {
        target.removeEventListener("transitionend", $68038d6a52830ca9$var$onPlayerMinTransition);
        if (window.innerWidth <= 1080) (0, $7cf89b289946013e$export$2621802d134c4be1).classList.remove("audio-player-margin-change");
        (0, $7cf89b289946013e$export$ee304df6759b31d9).classList.add("no-display");
        (0, $7cf89b289946013e$export$753dd2fa9d2ea4eb).classList.remove("no-display");
        (0, $kHwbY.rootDoc).classList.remove("no-scroll");
        (0, $kHwbY.rootDoc).classList.remove("no-select");
        (0, $0d29b55a1648e022$export$dcbe983eebabe3ad)(false);
        (0, $04d78f56f2937827$export$7b0d3317162e73ac)();
    }
}
function $68038d6a52830ca9$export$1707dd3e1c8aa93b() {
    if ((0, $7cf89b289946013e$export$ee304df6759b31d9).classList.contains("no-display")) {
        if (window.innerWidth > 1080) $68038d6a52830ca9$var$onPlayerMax();
        else {
            (0, $7cf89b289946013e$export$2621802d134c4be1).classList.remove("cubic-bezier");
            (0, $7cf89b289946013e$export$2621802d134c4be1).classList.add("audio-player-margin-change");
            setTimeout(()=>{
                (0, $7cf89b289946013e$export$2621802d134c4be1).classList.add("cubic-bezier");
                $68038d6a52830ca9$var$onPlayerMax();
            }, 100);
        }
    } else $68038d6a52830ca9$export$e492ffcefbc39bd2();
}



function $04d78f56f2937827$var$marqueeHandler(elText, elSpan) {
    const style = window.getComputedStyle(elText);
    const padding = parseFloat(style.paddingLeft) * 2;
    const computedWidth = (elText.offsetWidth - padding) * .95; //95% due to marquee fade
    if (elSpan.offsetWidth >= computedWidth) elText.classList.add("marquee-change");
    else elText.classList.remove("marquee-change");
}
function $04d78f56f2937827$export$7b0d3317162e73ac() {
    const el = (0, $0d29b55a1648e022$export$7c55482e4966fd92) ? (0, $7cf89b289946013e$export$ee304df6759b31d9) : (0, $7cf89b289946013e$export$753dd2fa9d2ea4eb);
    const title = (0, $kHwbY.$)(el, ".player-title")[0];
    const span = (0, $kHwbY.$)(title, "span")[0];
    $04d78f56f2937827$var$marqueeHandler(title, span);
    if (0, $0d29b55a1648e022$export$7c55482e4966fd92) {
        const album = (0, $kHwbY.$)((0, $7cf89b289946013e$export$ee304df6759b31d9), ".player-album")[0];
        const artist = (0, $kHwbY.$)(el, ".player-artist")[0];
        const tracks = (0, $kHwbY.$)(el, ".player-track");
        tracks.forEach((track)=>{
            const trackSpan = (0, $kHwbY.$)(track, "span")[0];
            $04d78f56f2937827$var$marqueeHandler(track, trackSpan);
        });
        $04d78f56f2937827$var$marqueeHandler(album, (0, $7cf89b289946013e$export$e1832d917d57b24a));
        $04d78f56f2937827$var$marqueeHandler(artist, (0, $7cf89b289946013e$export$3294cd9f8252944f));
    }
}
function $04d78f56f2937827$export$da43a660f7dc275c() {
    if (!(0, $7cf89b289946013e$export$2621802d134c4be1).classList.contains("no-display") && (0, $7cf89b289946013e$export$2621802d134c4be1).classList.contains("audio-player-max")) (0, $68038d6a52830ca9$export$e492ffcefbc39bd2)();
}



function $cfd0640867582a91$export$6440977e9a83981a(el, cl) {
    el.classList.remove(cl);
    const otherEl = el === (0, $7cf89b289946013e$export$38e42c68cf43b5d4) ? (0, $7cf89b289946013e$export$7d17b6c055672cbf) : (0, $7cf89b289946013e$export$38e42c68cf43b5d4);
    const otherCl = cl === "transform-sbleft" ? "transform-sbright" : "transform-sbleft";
    if (window.innerWidth <= 1080 && !otherEl.classList.contains(otherCl)) $cfd0640867582a91$export$7b9b8143590abcbd(otherEl, otherCl);
}
function $cfd0640867582a91$export$7b9b8143590abcbd(el, cl) {
    el.classList.add(cl);
}
function $cfd0640867582a91$export$4e064324386c3fa0() {
    if ((0, $7cf89b289946013e$export$38e42c68cf43b5d4).classList.contains("transform-sbleft")) $cfd0640867582a91$export$6440977e9a83981a((0, $7cf89b289946013e$export$38e42c68cf43b5d4), "transform-sbleft");
    else $cfd0640867582a91$export$7b9b8143590abcbd((0, $7cf89b289946013e$export$38e42c68cf43b5d4), "transform-sbleft");
}
function $cfd0640867582a91$export$f22e214e2467ca27() {
    (0, $7cf89b289946013e$export$7d17b6c055672cbf).addEventListener("transitionend", $cfd0640867582a91$var$onSBTransition);
    (0, $7cf89b289946013e$export$2621802d134c4be1).classList.remove("cubic-bezier");
    (0, $7cf89b289946013e$export$2621802d134c4be1).classList.add("ease-out");
    if ((0, $7cf89b289946013e$export$7d17b6c055672cbf).classList.contains("transform-sbright")) {
        $cfd0640867582a91$export$6440977e9a83981a((0, $7cf89b289946013e$export$7d17b6c055672cbf), "transform-sbright");
        (0, $7cf89b289946013e$export$2621802d134c4be1).classList.remove("audio-player-change");
        (0, $7cf89b289946013e$export$c3c488c05aeea533).classList.remove("search-sb-change");
    } else {
        $cfd0640867582a91$export$7b9b8143590abcbd((0, $7cf89b289946013e$export$7d17b6c055672cbf), "transform-sbright");
        if (window.innerWidth > 1080) {
            (0, $7cf89b289946013e$export$2621802d134c4be1).classList.add("audio-player-change");
            (0, $7cf89b289946013e$export$c3c488c05aeea533).classList.add("search-sb-change");
        }
    }
}
function $cfd0640867582a91$var$onSBTransition(e) {
    e = e || window.event;
    const currentTarget = e.currentTarget;
    if (e.propertyName === "transform") {
        currentTarget.removeEventListener("transitionend", $cfd0640867582a91$var$onSBTransition);
        (0, $7cf89b289946013e$export$2621802d134c4be1).classList.remove("ease-out");
        (0, $7cf89b289946013e$export$2621802d134c4be1).classList.add("cubic-bezier");
        (0, $04d78f56f2937827$export$7b0d3317162e73ac)();
    }
}


function $4fe4a05be5f01752$export$45b39e67d4ce4921() {
    const vh = window.innerHeight / 100;
    (0, $kHwbY.rootDoc).style.setProperty("--vh", vh + "px");
    if (window.innerWidth > 1080) {
        (0, $cfd0640867582a91$export$6440977e9a83981a)((0, $7cf89b289946013e$export$38e42c68cf43b5d4), "transform-sbleft");
        (0, $cfd0640867582a91$export$6440977e9a83981a)((0, $7cf89b289946013e$export$7d17b6c055672cbf), "transform-sbright");
        (0, $7cf89b289946013e$export$2621802d134c4be1).classList.remove("audio-player-change");
        (0, $7cf89b289946013e$export$c3c488c05aeea533).classList.remove("search-sb-change");
    }
}





var $kHwbY = parcelRequire("kHwbY");

var $gUYbp = parcelRequire("gUYbp");


var $fHkK7 = parcelRequire("fHkK7");
function $a44a30207bc31021$export$45360658e338ef80(e) {
    e.preventDefault();
    (0, $fHkK7.onRequest)((0, $7cf89b289946013e$export$b43fcfc8816565e2));
    const name = (0, $7cf89b289946013e$export$3713cb6ee3daa0ed).value.trim();
    const email = (0, $7cf89b289946013e$export$216bebe50ea21113).value.trim().toLowerCase();
    const msg = (0, $7cf89b289946013e$export$4bf98324584a107b).value.trim();
    const payload = {
        name: name,
        email: email,
        msg: msg
    };
    $a44a30207bc31021$var$submitContactMsg(payload, (0, $7cf89b289946013e$export$b43fcfc8816565e2));
}
async function $a44a30207bc31021$var$submitContactMsg(payload, btn) {
    const resp = await (0, $gUYbp.fetchAPI)("/contact-form", "POST", payload);
    (0, $fHkK7.onResponse)(btn);
    $a44a30207bc31021$var$appendContactResult(resp);
    if (resp && resp.success) (0, $dbfc4292d7c933aa$export$a2a1e8c320d4e05d)((0, $7cf89b289946013e$export$650cc1adfbebd6d7));
}
function $a44a30207bc31021$var$appendContactResult(data) {
    const pResult = (0, $kHwbY.$)((0, $7cf89b289946013e$export$650cc1adfbebd6d7), ".contact-result")[0];
    if (pResult) pResult.remove();
    const classes = data && data.success ? "contact-result" : "contact-result error";
    const resultText = data && data.success ? "Thank you, your message has been sent successfully" : "An error has occured while submitting your form<br>Please try again";
    const p = (0, $kHwbY.createElWithHTML)("p", classes, resultText);
    (0, $7cf89b289946013e$export$650cc1adfbebd6d7).append(p);
}




var $kHwbY = parcelRequire("kHwbY");

var $gUYbp = parcelRequire("gUYbp");


var $fHkK7 = parcelRequire("fHkK7");
function $460dce52bdf4fd6e$export$df2c4cf992b479a4() {
    (0, $kHwbY.rootDoc).classList.add("no-scroll");
    (0, $7cf89b289946013e$export$fceceec671b9a03e).classList.remove("no-display");
    setTimeout(()=>{
        (0, $7cf89b289946013e$export$fceceec671b9a03e).classList.add("overlay-change");
    }, 10);
}
function $460dce52bdf4fd6e$export$bc27390407ff67c6(e) {
    e.preventDefault();
    (0, $fHkK7.onRequest)((0, $7cf89b289946013e$export$d36e32ebd1790b56));
    const name = (0, $7cf89b289946013e$export$70e6340d6978c8c9).value.trim();
    const email = (0, $7cf89b289946013e$export$2c68f429695ceeec).value.trim().toLowerCase();
    grecaptcha.ready(function() {
        grecaptcha.execute("6LepwKcZAAAAALHJ-g5QhATrueyfdUvqFFAkTJ2o", {
            action: "subscribe"
        }).then(function(token) {
            const payload = {
                name: name,
                email: email,
                token: token
            };
            $460dce52bdf4fd6e$var$submitSubscriber(payload, (0, $7cf89b289946013e$export$d36e32ebd1790b56));
        });
    });
}
async function $460dce52bdf4fd6e$var$submitSubscriber(payload, btn) {
    const resp = await (0, $gUYbp.fetchAPI)("/subscribe", "POST", payload);
    (0, $fHkK7.onResponse)(btn);
    if (resp && resp.error) {
        $460dce52bdf4fd6e$var$onSubmitError(resp.error);
        return;
    }
    $460dce52bdf4fd6e$var$onSubmitSuccess(resp.success);
}
function $460dce52bdf4fd6e$var$onSubmitSuccess(success) {
    (0, $7cf89b289946013e$export$2132b0054e3f7d8b).classList.add("no-display");
    (0, $7cf89b289946013e$export$817f678afff6e146).classList.remove("no-display");
    const p = (0, $kHwbY.$)((0, $7cf89b289946013e$export$fceceec671b9a03e), ".subscribe-result")[0];
    p.classList.remove("no-display");
    p.innerText = !success ? "YOU ARE ALREADY SUBSCRIBED" : "THANK YOU FOR SUBSCRIBING TO MOROCCAN TAPES";
}
function $460dce52bdf4fd6e$var$onSubmitError(error) {
    (0, $7cf89b289946013e$export$2132b0054e3f7d8b).classList.add("no-display");
    (0, $7cf89b289946013e$export$678ceb1569114bf0).classList.remove("no-display");
    const p = (0, $kHwbY.$)((0, $7cf89b289946013e$export$fceceec671b9a03e), ".subscribe-result")[0];
    p.classList.remove("no-display");
    p.innerText = "AN ERROR HAS OCCURED WHILE SUBMITTING YOUR FORM";
}
function $460dce52bdf4fd6e$export$db1bd3463f3b105a() {
    (0, $dbfc4292d7c933aa$export$a2a1e8c320d4e05d)((0, $7cf89b289946013e$export$7b451d4caa7d79cb));
    (0, $7cf89b289946013e$export$2132b0054e3f7d8b).classList.remove("no-display");
    (0, $7cf89b289946013e$export$817f678afff6e146).classList.add("no-display");
    (0, $7cf89b289946013e$export$678ceb1569114bf0).classList.add("no-display");
    const p = (0, $kHwbY.$)((0, $7cf89b289946013e$export$fceceec671b9a03e), ".subscribe-result")[0];
    p.classList.add("no-display");
    p.innerText = "";
}




var $kHwbY = parcelRequire("kHwbY");




var $kHwbY = parcelRequire("kHwbY");


var $kHwbY = parcelRequire("kHwbY");




var $kHwbY = parcelRequire("kHwbY");




var $kHwbY = parcelRequire("kHwbY");



var $kHwbY = parcelRequire("kHwbY");

var $gUYbp = parcelRequire("gUYbp");

async function $8f5d462acc8dd2d0$export$5320f7bd627cf19(tapeID) {
    (0, $7cf89b289946013e$export$d8427b733004933d).append((0, $kHwbY.createCommentsLoader)());
    (0, $438c912f46128e91$export$93e55bb748e025f2)();
    const resp = await (0, $gUYbp.fetchAPI)("/get-comments", "POST", {
        tapeID: tapeID
    });
    if (!resp || resp && resp.error) {
        console.error(resp.error);
        return;
    }
    if ((0, $7cf89b289946013e$export$e5327212f4498715) != resp.tapeID) return;
    (0, $438c912f46128e91$export$db198b58be172276)(resp.comments, resp.tapeID);
}




var $kHwbY = parcelRequire("kHwbY");





var $kHwbY = parcelRequire("kHwbY");


function $0c747ecc2448bca3$export$4ae9183b5d586e85() {
    const tracks = (0, $kHwbY.$)((0, $7cf89b289946013e$export$d10ac07439c9d6e9), ".tracks");
    tracks.forEach((tr)=>tr.addEventListener("click", (0, $0d29b55a1648e022$export$a046f014b0330bfe)));
    const albumCover = (0, $kHwbY.$)((0, $7cf89b289946013e$export$d10ac07439c9d6e9), ".album-cover")[0];
    albumCover.addEventListener("click", $0c747ecc2448bca3$var$onAlbumOverlay);
    const label = (0, $kHwbY.$)((0, $7cf89b289946013e$export$d10ac07439c9d6e9), ".label")[0];
    label.addEventListener("click", (0, $6b3bd61e8899f4eb$export$e01b143219c38040));
    const tags = (0, $kHwbY.$)((0, $7cf89b289946013e$export$d10ac07439c9d6e9), ".tags");
    tags.forEach((t)=>t.addEventListener("click", (0, $6b3bd61e8899f4eb$export$a3805117c4d832e5)));
    (0, $kHwbY._)("playAlbumBtn").addEventListener("click", (0, $0d29b55a1648e022$export$a046f014b0330bfe));
}
function $0c747ecc2448bca3$export$e094bf80048ef493() {
    (0, $7cf89b289946013e$export$81f0481d70653cd4).addEventListener("click", $0c747ecc2448bca3$export$9eb04d8c59536908);
    (0, $7cf89b289946013e$export$91a5805f21dad009).addEventListener("click", $0c747ecc2448bca3$export$38e8493f1ce60eaa);
    (0, $7cf89b289946013e$export$c737a01d319fcd74).addEventListener("click", $0c747ecc2448bca3$export$2d4a820fa6048802);
    (0, $7cf89b289946013e$export$84cce35a26611d0c).addEventListener("click", $0c747ecc2448bca3$export$b66be810be6cea50);
}
function $0c747ecc2448bca3$export$9eb04d8c59536908() {
    const url = this.getAttribute("data-url");
    const a = (0, $kHwbY.createEl)("a", "", {
        href: url,
        download: ""
    });
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
function $0c747ecc2448bca3$export$38e8493f1ce60eaa() {
    const url = this.getAttribute("data-url");
    window.open(`https://www.facebook.com/sharer.php?u=https%3A%2F%2Fmoroccantapes.com%2F${url}`, "popup", "width=600,height=600");
}
function $0c747ecc2448bca3$export$2d4a820fa6048802() {
    const url = this.getAttribute("data-url");
    window.open(`http://www.twitter.com/intent/tweet?url=https://moroccantapes.com%2F${url}`, "popup", "width=600,height=600");
}
function $0c747ecc2448bca3$export$b66be810be6cea50() {
    const url = this.getAttribute("data-url");
    const artist = (0, $44cbc0a851a934db$export$e770ebccaf7adcda)(this.getAttribute("data-artist"), "&", "and");
    const album = this.getAttribute("data-album");
    const a = (0, $kHwbY.createEl)("a", "", {
        href: `mailto:?subject=${artist} - ${album}&body=Check this tape out - https://moroccantapes.com/${url}`
    });
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
//ALBUM COVER OVERLAY
function $0c747ecc2448bca3$var$onAlbumOverlay() {
    const width = Math.min(window.innerWidth - 60, window.innerHeight - 150);
    (0, $7cf89b289946013e$export$5b895045d367a315).setAttribute("src", this.getAttribute("src"));
    (0, $7cf89b289946013e$export$5b895045d367a315).setAttribute("alt", this.getAttribute("alt"));
    (0, $kHwbY.rootDoc).style.setProperty("--imgWidth", width + "px");
    (0, $kHwbY.rootDoc).classList.add("no-scroll");
    (0, $7cf89b289946013e$export$6900740f5ed31f0c).classList.remove("no-display");
    setTimeout(()=>{
        (0, $7cf89b289946013e$export$6900740f5ed31f0c).classList.add("overlay-change");
    }, 10);
    setTimeout(()=>{
        (0, $7cf89b289946013e$export$c40d5dfedea4cbef).innerText = this.getAttribute("alt");
    }, 100);
}


function $ad7fc5ec583d45ec$export$880b5d3b0d214619(tape, state) {
    document.documentElement.scrollTop = 0;
    const artistH = (0, $kHwbY.createElWithHTML)("h1", "artist-h1", tape.t_artist);
    const albumH = (0, $kHwbY.createElWithHTML)("h2", "album-h2", tape.t_album);
    const playBtn = (0, $kHwbY.createBtn)("btns ease-out", {
        type: "button",
        id: "playAlbumBtn",
        title: "Play Album",
        text: "Play Album",
        "data-id": tape.t_id.toString(),
        "data-track": "0"
    });
    const albumCover = (0, $kHwbY.createImageEl)("album-cover", {
        src: tape.t_assets.img_src,
        alt: `${tape.t_artist.toUpperCase()} - ${tape.t_album}`
    });
    const fragments = [
        artistH,
        albumH,
        playBtn,
        albumCover,
        $ad7fc5ec583d45ec$var$createTapeDesc(tape.t_date, tape.t_desc),
        $ad7fc5ec583d45ec$var$createTapeSides(tape.t_assets.sideA, tape.t_id, "SIDE A", 0),
        $ad7fc5ec583d45ec$var$createTapeSides(tape.t_assets.sideB, tape.t_id, "SIDE B", tape.t_assets.sideB.length),
        $ad7fc5ec583d45ec$var$createTags(tape.t_label, tape.t_tag, tape.t_genre)
    ];
    const fragment = (0, $kHwbY.createFragment)(fragments);
    (0, $7cf89b289946013e$export$d10ac07439c9d6e9).innerHTML = "";
    (0, $7cf89b289946013e$export$d8427b733004933d).innerHTML = "";
    (0, $7cf89b289946013e$export$d10ac07439c9d6e9).append(fragment);
    (0, $7cf89b289946013e$export$873130819acc7f7)(tape.t_id);
    $ad7fc5ec583d45ec$var$updateShareDl(tape);
    (0, $8f5d462acc8dd2d0$export$5320f7bd627cf19)(tape.t_id);
    (0, $0c747ecc2448bca3$export$4ae9183b5d586e85)();
    if (!state) (0, $99e8641219e4f7b6$export$7d639da0079739d5)(tape.t_url, false);
    (0, $7cf89b289946013e$export$d10ac07439c9d6e9).setAttribute("data-url", tape.t_url);
}
function $ad7fc5ec583d45ec$var$createTapeDesc(date, desc) {
    const div = (0, $kHwbY.createEl)("div", "tape-content-wrapper");
    const dateEl = (0, $kHwbY.createElWithHTML)("h3", "", (0, $44cbc0a851a934db$export$3ae94a2503e890a1)(date));
    const descEl = (0, $kHwbY.createElWithHTML)("p", "tape-content-read", desc);
    div.append(dateEl, descEl);
    return div;
}
function $ad7fc5ec583d45ec$var$createTapeSides(side, tapeId, sideTitle, count) {
    const div = (0, $kHwbY.createEl)("div", "tape-content-wrapper");
    const sideEl = (0, $kHwbY.createElWithHTML)("p", "tape-content-titles", sideTitle);
    div.append(sideEl);
    side.forEach((tr)=>{
        div.append((0, $kHwbY.createElWithHTML)("p", "tracks links ease-out", `${tr.title}<span>${$ad7fc5ec583d45ec$var$createPlayBtn()}</span>`, {
            "data-track": count,
            "data-id": tapeId
        }));
        count++;
    });
    return div;
}
function $ad7fc5ec583d45ec$var$createPlayBtn() {
    return `
        <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" class="tracks-play-svg">
            <title>Play</title>
            <path fill="#000"
                d="m6.38002,0.475025l0,59.049949l47.239959,-29.524975l-47.239959,-29.524975l0,0z" />
            </svg>`;
}
function $ad7fc5ec583d45ec$var$createTags(label, tags, genres) {
    const div = (0, $kHwbY.createEl)("div", "tape-content-wrapper");
    const labelTitle = (0, $kHwbY.createElWithHTML)("p", "tape-content-titles", "LABEL");
    const labelEl = (0, $kHwbY.createElWithHTML)("p", "links label", label, {
        "data-tag": label
    });
    const tagTitle = (0, $kHwbY.createElWithHTML)("p", "tape-content-titles", "TAGS");
    div.append(labelTitle, labelEl, tagTitle);
    const allTags = genres.concat(tags);
    allTags.forEach((tag)=>{
        div.append((0, $kHwbY.createElWithHTML)("button", "tags ease-out", tag, {
            type: "button",
            "data-tag": tag
        }));
    });
    return div;
}
function $ad7fc5ec583d45ec$var$updateShareDl(tape) {
    (0, $7cf89b289946013e$export$81f0481d70653cd4).setAttribute("data-url", tape.t_assets.zip_src);
    (0, $7cf89b289946013e$export$91a5805f21dad009).setAttribute("data-url", tape.t_url);
    (0, $7cf89b289946013e$export$c737a01d319fcd74).setAttribute("data-url", tape.t_url);
    (0, $7cf89b289946013e$export$84cce35a26611d0c).setAttribute("data-url", tape.t_url);
    (0, $7cf89b289946013e$export$84cce35a26611d0c).setAttribute("data-artist", tape.t_artist);
    (0, $7cf89b289946013e$export$84cce35a26611d0c).setAttribute("data-album", tape.t_album);
}



function $99e8641219e4f7b6$export$7d639da0079739d5(url, onInitialLoad) {
    const tape = (0, $7cf89b289946013e$export$6f6ad33723708cc7)(url);
    if (!tape) return;
    const state = {
        id: tape.t_id
    };
    const title = `${tape.t_artist} - ${tape.t_album}`;
    if (onInitialLoad) history.replaceState(state, title, `/${url}`);
    else history.pushState(state, title, `/${url}`);
    document.title = title;
}
function $99e8641219e4f7b6$export$9d7b2d4bf61e52db(url, onInitialLoad) {
    const state = {
        page: url
    };
    const title = $99e8641219e4f7b6$var$titleSwitch(url);
    if (onInitialLoad) history.replaceState(state, title, `/${url}`);
    else history.pushState(state, title, `/${url}`);
    document.title = title;
}
function $99e8641219e4f7b6$export$ecc95426d348e5b1(e) {
    e.preventDefault();
    const state = e.state;
    if (!state) return;
    if (state.id) {
        const aLink = (0, $7cf89b289946013e$export$c2dd313c040ea211).find((node)=>node.getAttribute("data-page") === "tapes");
        const ev = new Event("click");
        (0, $08613c39acfee78c$export$7ca0c7c6aa04b737)(ev, aLink, true);
        const tape = (0, $7cf89b289946013e$export$f146105b872a2433)(state.id);
        if (!tape) return;
        (0, $ad7fc5ec583d45ec$export$880b5d3b0d214619)(tape, true);
    } else {
        const aLink = (0, $7cf89b289946013e$export$c2dd313c040ea211).find((node)=>node.getAttribute("data-page") === state.page);
        const ev = new Event("click");
        (0, $08613c39acfee78c$export$7ca0c7c6aa04b737)(ev, aLink, true);
    }
}
function $99e8641219e4f7b6$var$titleSwitch(url) {
    let title = "";
    switch(url){
        case "about":
            title = "Moroccan Tapes | ABOUT";
            break;
        case "contact":
            title = "Moroccan Tapes | CONTACT";
            break;
        case "privacy-policy":
            title = "Moroccan Tapes | PRIVACY POLICY";
            break;
        case "site-info":
            title = "Moroccan Tapes | SITE INFO";
            break;
    }
    return title;
}


function $08613c39acfee78c$export$7ca0c7c6aa04b737(e, target, onPop) {
    e.preventDefault(); //PREVENT REQUESTING PAGE AND REFRESHING
    const currentTarget = target ? target : e.currentTarget;
    const page = currentTarget.getAttribute("data-page");
    if ((0, $7cf89b289946013e$export$efad93080758a558) != page) {
        (0, $7cf89b289946013e$export$c2dd313c040ea211).forEach((a)=>a.classList.remove("nav-current"));
        currentTarget.classList.add("nav-current");
        (0, $7cf89b289946013e$export$da3bc2f57520e3c3).forEach((p)=>p.classList.add("no-display"));
        $08613c39acfee78c$var$switchPage(page, onPop);
        if (window.innerWidth <= 1080) (0, $cfd0640867582a91$export$7b9b8143590abcbd)((0, $7cf89b289946013e$export$38e42c68cf43b5d4), "transform-sbleft");
        document.documentElement.scrollTop = 0;
        (0, $7cf89b289946013e$export$5e52cab53995b7b9)(page);
        (0, $04d78f56f2937827$export$da43a660f7dc275c)();
    }
}
function $08613c39acfee78c$var$switchPage(page, onPop) {
    switch(page){
        case "about":
            (0, $7cf89b289946013e$export$bf1d917a35fc3808).classList.remove("no-display");
            (0, $kHwbY.$)((0, $7cf89b289946013e$export$ae8d5403ba7bd299), "span")[0].innerText = "ABOUT";
            if (!onPop) (0, $99e8641219e4f7b6$export$9d7b2d4bf61e52db)(page, false);
            break;
        case "tapes":
            (0, $7cf89b289946013e$export$9d6f38182ab5a58).classList.remove("no-display");
            (0, $kHwbY.$)((0, $7cf89b289946013e$export$ae8d5403ba7bd299), "span")[0].innerText = "TAPES";
            if (!onPop) {
                const url = (0, $7cf89b289946013e$export$d10ac07439c9d6e9).getAttribute("data-url");
                (0, $99e8641219e4f7b6$export$7d639da0079739d5)(url, false);
            }
            break;
        case "contact":
            (0, $7cf89b289946013e$export$b66170c5a49216c1).classList.remove("no-display");
            (0, $kHwbY.$)((0, $7cf89b289946013e$export$ae8d5403ba7bd299), "span")[0].innerText = "CONTACT";
            if (!onPop) (0, $99e8641219e4f7b6$export$9d7b2d4bf61e52db)(page, false);
            break;
        case "privacy-policy":
            (0, $7cf89b289946013e$export$9fb42d980985e1e5).classList.remove("no-display");
            (0, $kHwbY.$)((0, $7cf89b289946013e$export$ae8d5403ba7bd299), "span")[0].innerText = "PRIVACY POLICY";
            if (!onPop) (0, $99e8641219e4f7b6$export$9d7b2d4bf61e52db)(page, false);
            break;
        case "site-info":
            (0, $7cf89b289946013e$export$2659b5099c14f2d9).classList.remove("no-display");
            (0, $kHwbY.$)((0, $7cf89b289946013e$export$ae8d5403ba7bd299), "span")[0].innerText = "SITE INFO";
            if (!onPop) (0, $99e8641219e4f7b6$export$9d7b2d4bf61e52db)(page, false);
    }
}



function $f6f3b77a67c4bda2$export$4e3aa0659304b3ec() {
    const thumbs = (0, $kHwbY.$)((0, $7cf89b289946013e$export$dbb963b0b4c07ccb), ".thumb");
    thumbs.forEach((thumb)=>thumb.addEventListener("click", $f6f3b77a67c4bda2$export$2378e8cbacff9c66));
}
function $f6f3b77a67c4bda2$export$2378e8cbacff9c66() {
    const id = Number(this.getAttribute("data-id"));
    if ((0, $7cf89b289946013e$export$e5327212f4498715) != id) {
        if (window.innerWidth <= 1080) (0, $cfd0640867582a91$export$7b9b8143590abcbd)((0, $7cf89b289946013e$export$7d17b6c055672cbf), "transform-sbright");
        const tape = (0, $7cf89b289946013e$export$f146105b872a2433)(id);
        if (tape) (0, $ad7fc5ec583d45ec$export$880b5d3b0d214619)(tape);
        (0, $04d78f56f2937827$export$da43a660f7dc275c)();
    }
    if ((0, $7cf89b289946013e$export$efad93080758a558) != "tapes") {
        const aLink = (0, $7cf89b289946013e$export$c2dd313c040ea211).find((node)=>node.getAttribute("data-page") === "tapes");
        const ev = new Event("click");
        (0, $08613c39acfee78c$export$7ca0c7c6aa04b737)(ev, aLink);
    }
}


function $4f7442bdfa8935d6$export$a880d1c1b9257221(data) {
    const fragments = [];
    data.forEach((row)=>{
        const div = (0, $kHwbY.createEl)("div", "thumb textOverImage bckg bckg-right no-scroll ease-out", {
            "data-title": row.t_artist,
            "data-album": row.t_album,
            "data-id": row.t_id,
            style: `background-image: url(${row.t_assets.img_src});`
        });
        fragments.push(div);
    });
    const fragment = (0, $kHwbY.createFragment)(fragments);
    (0, $7cf89b289946013e$export$dbb963b0b4c07ccb).innerHTML = "";
    (0, $7cf89b289946013e$export$dbb963b0b4c07ccb).append(fragment);
    const thumbs = (0, $kHwbY.$)((0, $7cf89b289946013e$export$dbb963b0b4c07ccb), ".thumb");
    thumbs.forEach((th)=>th.addEventListener("click", (0, $f6f3b77a67c4bda2$export$2378e8cbacff9c66)));
}


function $6b3bd61e8899f4eb$export$3d31318eb6f2a0b() {
    $6b3bd61e8899f4eb$export$b3e13d7f8e77223d(this.value);
}
function $6b3bd61e8899f4eb$export$b3e13d7f8e77223d(search) {
    if (!search || search === "") return;
    const results = search === "A-Z" ? (0, $5195ce8cc6653e87$export$6fa12653dd5e73ee)((0, $7cf89b289946013e$export$976d6f037fe75c00), "t_artist") : search === "All" ? (0, $5195ce8cc6653e87$export$22e259274f125c53)((0, $7cf89b289946013e$export$976d6f037fe75c00), "t_id") : (0, $5195ce8cc6653e87$export$6fa12653dd5e73ee)((0, $7cf89b289946013e$export$976d6f037fe75c00).filter((tape)=>tape.t_genre.includes(search)), "t_artist");
    const title = search === "A-Z" ? "A-Z" : search === "All" ? "ALL TAPES" : search.toUpperCase();
    $6b3bd61e8899f4eb$export$98d2bf0c2bd6a373(results, title);
}
function $6b3bd61e8899f4eb$export$e01b143219c38040() {
    const search = this.getAttribute("data-tag");
    const results = (0, $7cf89b289946013e$export$976d6f037fe75c00).filter((tape)=>tape.t_label.toLowerCase() === search.toLowerCase());
    const title = "LABEL";
    $6b3bd61e8899f4eb$export$98d2bf0c2bd6a373(results, title);
    $6b3bd61e8899f4eb$export$7af005c1eef8aeac(search);
}
function $6b3bd61e8899f4eb$export$a3805117c4d832e5() {
    const search = this.getAttribute("data-tag");
    const results = (0, $7cf89b289946013e$export$976d6f037fe75c00).filter((tape)=>tape.t_genre.includes(search) || tape.t_tag.includes(search));
    const title = search.toUpperCase();
    $6b3bd61e8899f4eb$export$98d2bf0c2bd6a373(results, title);
}
function $6b3bd61e8899f4eb$export$98d2bf0c2bd6a373(results, title) {
    (0, $7cf89b289946013e$export$7d17b6c055672cbf).scrollTop = 0;
    (0, $4f7442bdfa8935d6$export$a880d1c1b9257221)(results);
    (0, $7cf89b289946013e$export$763a95d341df07be).innerHTML = `CATALOG | <span>${title}</span>`;
    (0, $7cf89b289946013e$export$f2fe88e3db97d3a9).innerHTML = `${title}<span>(${results.length})</span>`;
    (0, $cfd0640867582a91$export$6440977e9a83981a)((0, $7cf89b289946013e$export$7d17b6c055672cbf), "transform-sbright");
}
function $6b3bd61e8899f4eb$export$7af005c1eef8aeac(search) {
    const p = (0, $kHwbY.createElWithHTML)("p", "", `Results for "${search}"`);
    (0, $7cf89b289946013e$export$f2fe88e3db97d3a9).append(p);
}







var $kHwbY = parcelRequire("kHwbY");


function $eab26d96ce7a46d8$export$76bfc926909101ab(result, search) {
    let count = 0;
    (0, $7cf89b289946013e$export$74fee65ef99e665c).innerHTML = "";
    (0, $7cf89b289946013e$export$c8049084115427e0).innerHTML = "";
    for(let key in result)if (result[key].length > 0) {
        const title = (0, $kHwbY.createElWithText)("p", "search-result-title", $eab26d96ce7a46d8$var$switchSearchProp(key), {
            "data-key": key
        });
        (0, $7cf89b289946013e$export$74fee65ef99e665c).append(title);
        if (count === 0) {
            title.classList.add("search-result-title-change");
            $eab26d96ce7a46d8$var$showSearchByTitle(result, search, key);
        }
        count++;
    }
    if (count === 0) {
        (0, $7cf89b289946013e$export$74fee65ef99e665c).innerHTML = '<p class="no-result">0 RESULTS</p>';
        $eab26d96ce7a46d8$var$adjustSearchHeight();
    }
    const titles = (0, $kHwbY.$)((0, $7cf89b289946013e$export$74fee65ef99e665c), ".search-result-title");
    titles.forEach((title)=>title.addEventListener("click", $eab26d96ce7a46d8$var$onSearchTitleClick));
}
function $eab26d96ce7a46d8$var$switchSearchProp(prop) {
    let title = "";
    switch(prop){
        case "t_artist":
            title = "Artist";
            break;
        case "t_album":
            title = "Album";
            break;
        case "t_label":
            title = "Label";
            break;
        case "t_track":
            title = "Track";
            break;
        case "t_tag":
            title = "Tag";
    }
    return title;
}
function $eab26d96ce7a46d8$var$showSearchByTitle(result, search, key) {
    (0, $7cf89b289946013e$export$c8049084115427e0).innerHTML = "";
    const div = (0, $kHwbY.createEl)("div", "search-result-container");
    result[key].forEach((e)=>{
        const res = (0, $kHwbY.createElWithHTML)("p", "search-result-item", $eab26d96ce7a46d8$var$highlightSearchResult(e, search), {
            "data-prop": key
        });
        div.append(res);
    });
    (0, $7cf89b289946013e$export$c8049084115427e0).append(div);
    $eab26d96ce7a46d8$var$addSearchListeners();
    (0, $7cf89b289946013e$export$38e42c68cf43b5d4).scrollTop = 0;
    $eab26d96ce7a46d8$var$adjustSearchHeight();
}
function $eab26d96ce7a46d8$var$highlightSearchResult(match, query) {
    const startIndex = match.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(query);
    if (startIndex === -1) return match;
    const endIndex = startIndex + query.length;
    return match.substring(0, startIndex) + `<mark>${match.substring(startIndex, endIndex)}</mark>` + match.substring(endIndex, match.length);
}
function $eab26d96ce7a46d8$var$adjustSearchHeight() {
    const height = (0, $7cf89b289946013e$export$c8049084115427e0).scrollHeight + 129; //129 = SEARCH HEADER HEIGHT + SEARCH TITLES HEIGHT
    (0, $kHwbY.rootDoc).style.setProperty("--searchHeight", height + "px");
    (0, $7cf89b289946013e$export$c3c488c05aeea533).classList.add("search-results-change");
}
function $eab26d96ce7a46d8$var$onSearchTitleClick() {
    const search = (0, $7cf89b289946013e$export$952af3258ed45903).value.toLowerCase().trim();
    const key = this.getAttribute("data-key");
    const titles = (0, $kHwbY.$)((0, $7cf89b289946013e$export$74fee65ef99e665c), ".search-result-title");
    titles.forEach((title)=>title.classList.remove("search-result-title-change"));
    this.classList.add("search-result-title-change");
    $eab26d96ce7a46d8$var$showSearchByTitle((0, $7cf89b289946013e$export$72029643ed737dbc), search, key);
}
function $eab26d96ce7a46d8$var$addSearchListeners() {
    const items = (0, $kHwbY.$)((0, $7cf89b289946013e$export$c8049084115427e0), ".search-result-item");
    items.forEach((item)=>item.addEventListener("click", $eab26d96ce7a46d8$var$onSearchResultClick));
}
function $eab26d96ce7a46d8$var$onSearchResultClick() {
    if (window.innerWidth <= 1080) (0, $c8a494bd98c5be1c$export$f8a295ecf910af4a)();
    else {
        (0, $7cf89b289946013e$export$c3c488c05aeea533).classList.remove("search-sb-change");
        (0, $7cf89b289946013e$export$2621802d134c4be1).classList.remove("audio-player-change");
    }
    const search = this.innerText;
    const prop = this.getAttribute("data-prop");
    const results = prop === "t_track" ? (0, $7cf89b289946013e$export$976d6f037fe75c00).filter((tape)=>{
        const sideA = tape.t_assets.sideA.map((item)=>{
            return item.title;
        });
        const sideB = tape.t_assets.sideB.map((item)=>{
            return item.title;
        });
        const tracks = sideA.concat(sideB);
        if (tracks.includes(search)) return tape;
    }) : prop === "t_tag" ? (0, $7cf89b289946013e$export$976d6f037fe75c00).filter((tape)=>{
        const tags = tape.t_genre.concat(tape.t_tag);
        if (tags.includes(search)) return tape;
    }) : (0, $7cf89b289946013e$export$976d6f037fe75c00).filter((tape)=>tape[prop].includes(search));
    const title = "SEARCH";
    (0, $6b3bd61e8899f4eb$export$98d2bf0c2bd6a373)(results, title);
    (0, $6b3bd61e8899f4eb$export$7af005c1eef8aeac)(search);
}


function $c8a494bd98c5be1c$export$494432f781574f2(e) {
    e = e || window.event;
    e.preventDefault();
    const target = e.currentTarget;
    const search = (0, $44cbc0a851a934db$export$7d68961ff6256c01)(target.value.toLowerCase().trim());
    if (search.length < 3) {
        $c8a494bd98c5be1c$export$f8a295ecf910af4a();
        return;
    }
    if (0, $7cf89b289946013e$export$3982463a07672884) document.documentElement.scrollTop = 0;
     //handle iphone scroll on input focus
    (0, $7cf89b289946013e$export$dd4db7a8de9ade16).classList.remove("no-display");
    (0, $7cf89b289946013e$export$dd4db7a8de9ade16).addEventListener("click", $c8a494bd98c5be1c$export$f8a295ecf910af4a);
    (0, $7cf89b289946013e$export$3bc667280e4eed3).addEventListener("click", $c8a494bd98c5be1c$export$f8a295ecf910af4a);
    (0, $7cf89b289946013e$export$3b4cac8c91b4220d)($c8a494bd98c5be1c$var$getSearchResults(search));
    (0, $eab26d96ce7a46d8$export$76bfc926909101ab)((0, $7cf89b289946013e$export$72029643ed737dbc), search);
    (0, $7cf89b289946013e$export$293a7ede9354bee0).innerText = (0, $44cbc0a851a934db$export$7d68961ff6256c01)(target.value.trim());
}
function $c8a494bd98c5be1c$export$f8a295ecf910af4a(e) {
    if (e?.target) (0, $7cf89b289946013e$export$952af3258ed45903).value = "";
    (0, $7cf89b289946013e$export$3b4cac8c91b4220d)({});
    (0, $7cf89b289946013e$export$dd4db7a8de9ade16).removeEventListener("click", $c8a494bd98c5be1c$export$f8a295ecf910af4a);
    (0, $7cf89b289946013e$export$dd4db7a8de9ade16).classList.add("no-display");
    (0, $7cf89b289946013e$export$3bc667280e4eed3).removeEventListener("click", $c8a494bd98c5be1c$export$f8a295ecf910af4a);
    (0, $7cf89b289946013e$export$c3c488c05aeea533).classList.remove("search-results-change");
    (0, $7cf89b289946013e$export$c8049084115427e0).innerHTML = "";
    (0, $7cf89b289946013e$export$74fee65ef99e665c).innerHTML = "";
    (0, $7cf89b289946013e$export$293a7ede9354bee0).innerText = "";
}
function $c8a494bd98c5be1c$var$getSearchResults(search) {
    const results = {
        t_artist: [],
        t_album: [],
        t_label: [],
        t_track: [],
        t_tag: []
    };
    const propList = [
        "t_artist",
        "t_album",
        "t_label"
    ];
    const arrayList = [
        "sideA",
        "sideB",
        "t_genre",
        "t_tag"
    ];
    propList.forEach((p)=>{
        const filtered = (0, $5195ce8cc6653e87$export$4563b0c2631818ea)((0, $7cf89b289946013e$export$976d6f037fe75c00), p, search);
        results[p] = Array.from(new Set((0, $5195ce8cc6653e87$export$d12f9c456f9edae9)(filtered, p)));
    });
    let tracks = [];
    let tags = [];
    arrayList.forEach((p)=>{
        let result = [];
        const list = p === "sideA" || p === "sideB" ? (0, $5195ce8cc6653e87$export$a1cc11fb93586ff0)((0, $7cf89b289946013e$export$976d6f037fe75c00), "t_assets", p) : (0, $5195ce8cc6653e87$export$d12f9c456f9edae9)((0, $7cf89b289946013e$export$976d6f037fe75c00), p);
        list.forEach((row)=>{
            let match = p === "sideA" || p === "sideB" ? (0, $5195ce8cc6653e87$export$d12f9c456f9edae9)((0, $5195ce8cc6653e87$export$4563b0c2631818ea)(row, "title", search), "title") : (0, $5195ce8cc6653e87$export$64a79c6b55760f81)(row, search);
            if (match.length > 0) match = Array.from(new Set(match));
            result = Array.from(new Set(result.concat(match)));
        });
        if (p === "sideA") tracks = result;
        if (p === "sideB") results.t_track = tracks.concat(result);
        if (p === "t_genre") tags = result;
        if (p === "t_tag") results[p] = tags.concat(result);
    });
    return results;
}







function $1ba6c8a89f72efb5$export$798ba9644b7c9d93() {
    const url = (0, $44cbc0a851a934db$export$e770ebccaf7adcda)(window.location.pathname, "/", "");
    if (url.length > 1) {
        const staticOn = $1ba6c8a89f72efb5$var$switchUrl(url);
        if (!staticOn) {
            (0, $99e8641219e4f7b6$export$7d639da0079739d5)(url, true);
            const aLink = (0, $7cf89b289946013e$export$c2dd313c040ea211).find((node)=>node.getAttribute("data-page") === "tapes");
            const ev = new Event("click");
            (0, $08613c39acfee78c$export$7ca0c7c6aa04b737)(ev, aLink, true);
        } else {
            (0, $99e8641219e4f7b6$export$9d7b2d4bf61e52db)(url, true);
            const aLink = (0, $7cf89b289946013e$export$c2dd313c040ea211).find((node)=>node.getAttribute("data-page") === url);
            const ev = new Event("click");
            (0, $08613c39acfee78c$export$7ca0c7c6aa04b737)(ev, aLink, true);
        }
    } else {
        const tapeUrl = (0, $7cf89b289946013e$export$976d6f037fe75c00)[0].t_url;
        (0, $99e8641219e4f7b6$export$7d639da0079739d5)(tapeUrl, true);
        const aLink = (0, $7cf89b289946013e$export$c2dd313c040ea211).find((node)=>node.getAttribute("data-page") === "tapes");
        const ev = new Event("click");
        (0, $08613c39acfee78c$export$7ca0c7c6aa04b737)(ev, aLink, true);
    }
}
function $1ba6c8a89f72efb5$var$switchUrl(url) {
    let staticOn = true;
    switch(url){
        case "about":
        case "contact":
        case "privacy-policy":
        case "site-info":
            break;
        default:
            staticOn = false;
    }
    return staticOn;
}





(0, $4fe4a05be5f01752$export$45b39e67d4ce4921)();
document.addEventListener("DOMContentLoaded", $5acd1fe8fefec0f3$var$onDOMLoaded);
window.addEventListener("resize", (0, $4fe4a05be5f01752$export$45b39e67d4ce4921));
window.addEventListener("popstate", (0, $99e8641219e4f7b6$export$ecc95426d348e5b1));
function $5acd1fe8fefec0f3$var$onDOMLoaded() {
    if (window.innerWidth <= 1340 && window.innerWidth > 1080) (0, $7cf89b289946013e$export$c3c488c05aeea533).classList.add("search-sb-change");
    (0, $7cf89b289946013e$export$7f0f66125aea4b08)("ontouchstart" in document.documentElement);
    const isInitialized = (0, $7cf89b289946013e$export$39ba075b3d63f433)();
    if (!isInitialized) {
        $5acd1fe8fefec0f3$var$showErrorOverlay();
        return;
    }
    (0, $1ba6c8a89f72efb5$export$798ba9644b7c9d93)();
    $5acd1fe8fefec0f3$var$addGlobalListeners();
    (0, $09dc04b5569317e1$export$e06c18951f081b66)();
}
function $5acd1fe8fefec0f3$var$addGlobalListeners() {
    //OVERLAYS
    (0, $7cf89b289946013e$export$7079e74b16e3deec).forEach((e)=>e.addEventListener("click", $5acd1fe8fefec0f3$var$onOverlayClick));
    //NAV
    (0, $7cf89b289946013e$export$c2dd313c040ea211).forEach((a)=>a.addEventListener("click", (0, $08613c39acfee78c$export$7ca0c7c6aa04b737)));
    //FORM SUBMITS
    (0, $7cf89b289946013e$export$952af3258ed45903).addEventListener("keyup", (0, $c8a494bd98c5be1c$export$494432f781574f2));
    (0, $7cf89b289946013e$export$f509bc23ec5ba01c).addEventListener("change", (0, $6b3bd61e8899f4eb$export$3d31318eb6f2a0b));
    (0, $7cf89b289946013e$export$285bd1d6c6bdf942).addEventListener("submit", (0, $9718690ab11358b5$export$a3f6de88479c02bd));
    (0, $7cf89b289946013e$export$297876223bd08729).addEventListener("click", (0, $460dce52bdf4fd6e$export$df2c4cf992b479a4));
    (0, $7cf89b289946013e$export$d14c904650badef2).addEventListener("click", $5acd1fe8fefec0f3$var$onCloseSubOverlayClick);
    (0, $7cf89b289946013e$export$7b451d4caa7d79cb).addEventListener("submit", (0, $460dce52bdf4fd6e$export$bc27390407ff67c6));
    (0, $7cf89b289946013e$export$650cc1adfbebd6d7).addEventListener("submit", (0, $a44a30207bc31021$export$45360658e338ef80));
    //SIDEBARS
    (0, $7cf89b289946013e$export$ae8d5403ba7bd299).addEventListener("click", (0, $cfd0640867582a91$export$4e064324386c3fa0));
    (0, $7cf89b289946013e$export$763a95d341df07be).addEventListener("click", (0, $cfd0640867582a91$export$f22e214e2467ca27));
    //THUMBS
    (0, $f6f3b77a67c4bda2$export$4e3aa0659304b3ec)();
    //TAPE PAGE LISTENERS
    (0, $0c747ecc2448bca3$export$4ae9183b5d586e85)();
    (0, $9718690ab11358b5$export$d8c3e97503d199bf)();
    (0, $0c747ecc2448bca3$export$e094bf80048ef493)();
    //REMOVE ZOOM ON MOBILE
    document.documentElement.addEventListener("touchstart", function(e) {}); //hover behaviour on touch devices
    const zoomEls = [
        (0, $7cf89b289946013e$export$c3c488c05aeea533),
        (0, $7cf89b289946013e$export$fc66f88975b715ac),
        ...(0, $7cf89b289946013e$export$7079e74b16e3deec),
        (0, $7cf89b289946013e$export$2621802d134c4be1)
    ];
    const zoomEvent = "onwheel" in document ? "wheel" : false;
    if (!zoomEvent) return;
    (0, $7cf89b289946013e$export$da3bc2f57520e3c3).forEach((page)=>page.addEventListener(zoomEvent, $5acd1fe8fefec0f3$var$zoomHandler));
    zoomEls.forEach((el)=>el.addEventListener(zoomEvent, $5acd1fe8fefec0f3$var$zoomHandler));
}
//ZOOM HANDLER
function $5acd1fe8fefec0f3$var$zoomHandler(e) {
    e = e || window.event;
    const delta = -(e.deltaY ? e.deltaY : e.detail);
    if (delta % 1 !== 0) e.preventDefault(); //prevent default pinch zoom
}
//OVERLAYS
function $5acd1fe8fefec0f3$var$onOverlayClick(e) {
    (0, $7cf89b289946013e$export$c40d5dfedea4cbef).innerText = "";
    const target = e.target;
    if (e.currentTarget === (0, $7cf89b289946013e$export$11f729d610486c22)) return;
    if (target.classList.contains("overlay")) $5acd1fe8fefec0f3$var$closeOverlay(e.currentTarget);
}
function $5acd1fe8fefec0f3$var$onCloseSubOverlayClick() {
    $5acd1fe8fefec0f3$var$closeOverlay((0, $7cf89b289946013e$export$fceceec671b9a03e));
}
function $5acd1fe8fefec0f3$var$closeOverlay(e) {
    (0, $kHwbY.rootDoc).classList.remove("no-scroll");
    e.classList.remove("overlay-change");
    setTimeout(()=>{
        e.classList.add("no-display");
        if (e === (0, $7cf89b289946013e$export$fceceec671b9a03e)) (0, $460dce52bdf4fd6e$export$db1bd3463f3b105a)();
    }, 400);
}
function $5acd1fe8fefec0f3$var$showErrorOverlay() {
    (0, $kHwbY.rootDoc).classList.add("no-scroll");
    (0, $kHwbY.rootDoc).classList.add("no-pointers");
    (0, $7cf89b289946013e$export$bf3914add3e8ddc4).classList.remove("no-display");
    setTimeout(()=>{
        (0, $7cf89b289946013e$export$bf3914add3e8ddc4).classList.add("overlay-change");
    }, 10);
}

})();
//# sourceMappingURL=index.59a55009.js.map
